import React, { useEffect, useState } from 'react';
import { extInSite } from './IvrShared';
import AdminShell from '../layouts/AdminShell';
import '../styles/admin.css';
import api from '../services/ApiService';
import AgentStatePanel from './AgentStatePanel';
import SupervisorMonitor from './SupervisorMonitor';
import QueueMonitor from './QueueMonitor';
import LiveCalls from './LiveCalls';
import SecurityBans from './SecurityBans';
import CdrPage from './CdrPage';
import IvrMenusPage from './IvrMenusPage';
import BusinessHoursPage from './BusinessHoursPage';
import CustomersPage, { ReceptionSettingsPage } from './CustomersPage';
import VoicemailPage from './VoicemailPage';
import axios from 'axios';
import { QueueSettingsModal, QueueLive, QueueReports, QueueMissed, QueueVoicemail, QueueTabBar } from './QueueCenter';
import { CustomerBar, useCustomer, loadCustomers, withPrefix, orgName } from './customerCtx';
import PbxSitesPage from './PbxSitesPage';
import SalesAgentPage from './SalesAgentPage';
import Wallboard from './Wallboard';
import ExtensionsPage from './ExtensionsPage';
import MoveUserDialog from './MoveUserDialog';
import CallHandlingDialog from './CallHandlingDialog';
import OperationsTeamPage, { OpsActivityCard } from './OperationsTeamPage';
import { SubAdminWallboard } from './ChangeAuditBoard';
import RecordingsLibraryPage from './RecordingsLibraryPage';
import DidsPage from './DidsPage';
import TrunksPage from './TrunksPage';
import DeployToProductionPage from './DeployToProductionPage';
import ReportsPage from './ReportsPage';
import ServerHealthPanel from './ServerHealthPanel';
import AsteriskPage from './AsteriskPage';
import AIConversations from './Conversations';
import AIKnowledgeBase from './KnowledgeBase';
import OpsKnowledgeBase from './OpsKnowledgeBase';
import VoiceBotsPage from './VoiceBotsPage';
import QueueAIManagement from './QueueAIManagement';
import AIReports from './Reports';
import AISettings from './Settings';
import WhatsAppSettings from './WhatsAppSettings';
import TranscriptsListPage from './TranscriptsListPage';
import TranscriptSearch from './TranscriptSearch';
import TranscriptionAdmin from './TranscriptionAdmin';
import BillingPage from './BillingPage';
import LicensesPage from './LicensesPage';
import PhonesPage from './PhonesPage';
import SpeedDialsPage from './SpeedDialsPage';
import TeamsSettingsPage from './TeamsSettingsPage';
import TeamsContactsPage from './TeamsContactsPage';
import TeamsAdminPage from './TeamsAdminPage';
import DemoManagement from './DemoManagement';
import SecurityPage from './SecurityPage';
import SettingsPage from './SettingsPage';
import DialingPolicyPage from './DialingPolicyPage';
import CallTracePage from './CallTracePage';
import BundlesPage from './BundlesPage';
import MenuAccessPage from './MenuAccessPage';
import ManagedTenantsPage from './ManagedTenantsPage';
import CRMIntegrationsPage from './crm/CRMIntegrationsPage';
import PickupGroupsAdmin from './PickupGroupsAdmin';
import CRMDashboard from './crm/CRMDashboard';
import CRMQueueMappingPage from './crm/CRMQueueMappingPage';
import CRMFieldMappingPage from './crm/CRMFieldMappingPage';
import { ZoomTable, ZoomBtn, ZoomBadge, ZoomModal, ZoomField } from './zoom/ZoomTable';
import DirectoryPage from './DirectoryPage';
import ExternalContactsPage from './ExternalContactsPage';
import DidInventoryPage from './DidInventoryPage';
import HealthCheckPage from './HealthCheckPage';
import CallFlowsPage from './CallFlowsPage';
import LocationSelect from './LocationSelect';
import GatewayManagementPage from './GatewayManagementPage';
import SbcManagementPage from './SbcManagementPage';

type AdminUser = {
  id: number;
  username: string;
  tenant_id?: number;
  role?: string;
  user_type?: string;
  cc_enabled?: number;
  queue_enabled?: number;
  supervisor_enabled?: number;
  is_active: number;
  is_admin: number;
  feature_recording: number;
  feature_contacts: number;
  feature_from_number: number;
  feature_recent_calls: number;
  feature_settings: number;
  feature_transfer: number;
  feature_queue_mode: number;
  feature_supervisor: number;
  feature_wallboard: number;
  feature_crm_popup: number;
  feature_ai_transcription: number;
  mobile_app_allowed?: number;
  ai_agent_enabled?: number;
  voice_bot_enabled?: number;
  first_name?: string;
  last_name?: string;
  department?: string;
  job_title?: string;
  location?: string;
  manager_id?: number | null;
  avatar_url?: string;
  email?: string;
  created_at?: string;
  extension_number?: string;
  display_name?: string;
};
type UserGroup = {
  id: number;
  tenant_id: number;
  name: string;
  description?: string;
  members?: { user_id: number; username: string; first_name?: string; last_name?: string }[];
};

type Tenant = {
  id: number;
  tenant_name: string;
  company_name?: string;
  domain_name?: string;
  contact_email?: string;
  max_users?: number;
  extension_base?: number;
  outbound_limit_enabled?: number;
  outbound_limit_minutes?: number;
  is_active: number;
  created_at?: string;
};

type Queue = {
  id: number;
  tenant_id: number;
  queue_name: string;
  display_name: string;
  strategy: string;
  priority: number;
  is_active: number;
  created_at?: string;
};

type QueueMember = {
  id: number;
  queue_id: number;
  user_id: number;
  username: string;
  penalty: number;
  is_active: number;
  state?: string;
  queue_name?: string;
  last_update?: string;
};


// ── Multi-site (branch) support — additive; Central path is untouched ────────
const BRANCH_FIELDS: any = {
  extensions: [['extension','Extension e.g. 8010'],['display_name','Display name'],['password','SIP password (blank = auto)']],
  trunks: [['trunk_name','Trunk name'],['sip_host','Gateway / SBC IP'],['sip_port','Port (5060)'],['auth_username','Auth user (blank = IP auth)'],['auth_password','Auth password'],['transport','Transport (udp/tcp/tls)']],
  dids: [['did_number','DID number e.g. +9712...'],['destination','Rings extension e.g. 8010']],
  queues: [['queue_name','Queue name'],['strategy','Strategy (ringall)'],['timeout','Ring timeout (20)'],['members','Member exts, comma-separated']],
};
const BRANCH_LABEL: any = {
  extensions: (r: any) => r.extension + '  —  ' + (r.display_name || ''),
  trunks: (r: any) => r.trunk_name + '  →  ' + r.sip_host + ':' + (r.sip_port || 5060),
  dids: (r: any) => r.did_number + '  →  ext ' + r.destination,
  queues: (r: any) => r.queue_name + '  ·  ' + (r.strategy || 'ringall') + (r.members ? ('  ·  [' + r.members + ']') : ''),
};
function SiteBar({ siteCtx, setSiteCtx, branchSites, pbxSites }: any) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '4px 0 18px' }}>
      <span style={{ fontSize: 13, color: '#6b7280' }}>Managing site:</span>
      <select value={siteCtx} onChange={(e) => setSiteCtx(e.target.value)} style={{ padding: '8px 12px', border: '1px solid #cdd2e6', borderRadius: 8, fontWeight: 600, background: '#fff' }}>
        <option value="central">{(pbxSites || []).length ? 'All sites' : 'Central — Dubai (main system)'}</option>
        {(pbxSites || []).map((s: any) => <option key={'pbx' + s.id} value={'pbx:' + s.id}>{s.by_assignment ? s.name : `${s.name} (${s.ext_start}-${s.ext_end})`}</option>)}
        {(branchSites || []).map((s: any) => <option key={s.id} value={String(s.id)}>{s.name} Edge (branch server)</option>)}
      </select>
      <CustomerBar />
      {siteCtx !== 'central' && !String(siteCtx).startsWith('pbx:') && <span style={{ fontSize: 12, color: '#5b5ef0', background: '#eef0fe', padding: '3px 10px', borderRadius: 999, fontWeight: 600 }}>Branch mode</span>}
    </div>
  );
}
const BRANCH_NAV_LABELS: any = { 'Voice Bots': 'Auto Receptionist' };
function BranchComingSoon({ page, siteName }: any) {
  const label = BRANCH_NAV_LABELS[page] || page;
  return (
    <div style={{ padding: 48, textAlign: 'center', color: '#6b7280' }}>
      <div style={{ fontSize: 20, fontWeight: 800, color: '#1f2430', marginBottom: 8 }}>{label}</div>
      <p style={{ maxWidth: 540, margin: '0 auto' }}>&ldquo;{label}&rdquo; for the <b>{siteName}</b> branch is coming soon. Users, Extensions, Trunks, DIDs, Queues and Dialing Policy are available now — or switch to <b>Central</b> to manage the main system.</p>
    </div>
  );
}
function BranchCentralOnly({ title, siteName, body }: any) {
  return (
    <div style={{ padding: 48, textAlign: 'center', color: '#6b7280' }}>
      <div style={{ fontSize: 20, fontWeight: 800, color: '#1f2430', marginBottom: 8 }}>{title}</div>
      <p style={{ maxWidth: 580, margin: '0 auto' }}>For the <b>{siteName}</b> branch, {body}</p>
    </div>
  );
}
function BranchDialingPolicy({ siteId, siteName }: any) {
  const [countries, setCountries] = React.useState<any[]>([]);
  const [allowed, setAllowed] = React.useState<Set<number>>(new Set());
  const [q, setQ] = React.useState('');
  const [msg, setMsg] = React.useState('');
  const [saving, setSaving] = React.useState(false);
  const tok = () => localStorage.getItem('token');
  const base = '/api/v1/admin/sites/' + siteId + '/dialing-policy';
  React.useEffect(() => {
    setMsg('');
    fetch(base, { headers: { Authorization: 'Bearer ' + tok() } })
      .then((r) => (r.ok ? r.json() : { countries: [], allowed: [] }))
      .then((d) => { setCountries(d.countries || []); setAllowed(new Set(d.allowed || [])); })
      .catch(() => {});
  }, [siteId]); // eslint-disable-line react-hooks/exhaustive-deps
  const toggle = (id: number) => setAllowed((sset) => { const n = new Set(sset); if (n.has(id)) n.delete(id); else n.add(id); return n; });
  const save = async () => {
    setSaving(true); setMsg('');
    try {
      const r = await fetch(base, { method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + tok() }, body: JSON.stringify({ country_ids: Array.from(allowed) }) });
      const d = await r.json();
      setMsg(r.ok ? ('Saved — ' + (d.count || 0) + ' countries allowed. Pushed to the branch server.') : (d.error || 'Save failed'));
    } catch (e: any) { setMsg(e.message || 'error'); } finally { setSaving(false); }
  };
  const filtered = countries.filter((c: any) => !q.trim() || (c.name + ' ' + c.iso2 + ' ' + c.dial_code).toLowerCase().includes(q.toLowerCase()));
  return (
    <div>
      <div style={{ marginBottom: 6 }}>
        <h2 style={{ margin: 0 }}>Dialing Policy</h2>
        <div style={{ color: '#6b7280', fontSize: 13, marginTop: 2 }}>
          Choose which countries the <b>{siteName}</b> branch may call. Local (UAE) and internal calls are always allowed; calls to countries not selected are blocked. Changes push to the branch server.
        </div>
      </div>
      <div style={{ display: 'flex', gap: 10, alignItems: 'center', margin: '14px 0' }}>
        <input placeholder="Search countries..." value={q} onChange={(e) => setQ(e.target.value)}
          style={{ flex: '0 0 280px', padding: '9px 12px', border: '1px solid #dde1ee', borderRadius: 8 }} />
        <span style={{ fontSize: 12, color: '#6b7280' }}>{allowed.size} selected</span>
        <div style={{ flex: 1 }} />
        <button className="primary-btn" onClick={save} disabled={saving}>{saving ? 'Saving...' : 'Save Policy'}</button>
      </div>
      {msg && <div className="admin-alert" style={{ marginBottom: 12 }}>{msg}</div>}
      <div style={{ background: '#fff', border: '1px solid #e5e7f0', borderRadius: 12, padding: 12, display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(230px,1fr))', gap: 6, maxHeight: '58vh', overflow: 'auto' }}>
        {filtered.map((c: any) => (
          <label key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 10px', borderRadius: 8, cursor: 'pointer', background: allowed.has(c.id) ? '#eef0fe' : 'transparent' }}>
            <input type="checkbox" checked={allowed.has(c.id)} onChange={() => toggle(c.id)} />
            <span style={{ fontSize: 14 }}>{c.name}</span>
            <span style={{ marginLeft: 'auto', fontSize: 12, color: '#8890a6' }}>+{String(c.dial_code || '').replace(/[^0-9]/g, '')}</span>
          </label>
        ))}
        {!filtered.length && <div style={{ padding: 18, color: '#8890a6' }}>No countries match.</div>}
      </div>
    </div>
  );
}
function BranchScreen({ kind, siteId, siteName }: any) {
  const [rows, setRows] = React.useState<any[]>([]);
  const [showAdd, setShowAdd] = React.useState(false);
  const [form, setForm] = React.useState<any>({});
  const [search, setSearch] = React.useState('');
  const [msg, setMsg] = React.useState('');
  const [exts, setExts] = React.useState<any[]>([]);
  const [qs, setQs] = React.useState<any[]>([]);
  const tokh = () => ({ Authorization: 'Bearer ' + (localStorage.getItem('token') || '') });
  const jsonh = () => ({ 'Content-Type': 'application/json', ...tokh() });
  const base = '/api/v1/admin/sites/' + siteId + '/' + kind;
  const load = () => fetch(base, { headers: tokh() }).then((r) => (r.ok ? r.json() : [])).then(setRows).catch(() => setRows([]));
  React.useEffect(() => {
    setRows([]); setSearch(''); setForm({}); load();
    if (kind === 'dids') {
      fetch('/api/v1/admin/sites/' + siteId + '/extensions', { headers: tokh() }).then((r) => (r.ok ? r.json() : [])).then(setExts).catch(() => {});
      fetch('/api/v1/admin/sites/' + siteId + '/queues', { headers: tokh() }).then((r) => (r.ok ? r.json() : [])).then(setQs).catch(() => {});
    }
  }, [kind, siteId]); // eslint-disable-line react-hooks/exhaustive-deps
  const patch = async (row: any, changes: any) => {
    setRows((rs) => rs.map((x) => (x.id === row.id ? { ...x, ...changes } : x)));
    try { await fetch(base + '/' + row.id, { method: 'PUT', headers: jsonh(), body: JSON.stringify(changes) }); } catch { /* keep optimistic */ }
    load();
  };
  const del = async (row: any) => {
    const lbl = row.extension || row.did_number || row.trunk_name || row.queue_name || 'this item';
    if (!window.confirm('Remove ' + lbl + ' from the ' + siteName + ' branch server?')) return;
    await fetch(base + '/' + row.id, { method: 'DELETE', headers: tokh() });
    load();
  };
  const create = async () => {
    setMsg('');
    try {
      const r = await fetch(base, { method: 'POST', headers: jsonh(), body: JSON.stringify(form) });
      const d = await r.json().catch(() => ({}));
      if (!r.ok) { setMsg(d.error || 'Could not save'); return; }
      setShowAdd(false); setForm({});
      if (kind === 'extensions' && d.sip_password) window.alert('Created ' + (d.extension || '') + '. SIP password (set on the phone): ' + d.sip_password);
      load();
    } catch (e: any) { setMsg(e.message || 'error'); }
  };
  const Pill = ({ on, label, onClick }: any) => (
    <button className={'z-badge ' + (on ? 'z-badge-green' : 'z-badge-gray')} style={{ border: 'none', cursor: 'pointer' }} onClick={onClick}>{label}</button>
  );
  const StatusPill = ({ row }: any) => (
    <button className={'z-badge ' + (row.is_active ? 'z-badge-green' : 'z-badge-red')} style={{ border: 'none', cursor: 'pointer' }}
      onClick={() => patch(row, { is_active: row.is_active ? false : true })}>{row.is_active ? 'Active' : 'Disabled'}</button>
  );
  const destOptions = (rt: string) => (rt === 'queue'
    ? qs.map((x: any) => ({ v: x.queue_name, l: (x.queue_name + (x.display_name ? ' - ' + x.display_name : '')) }))
    : exts.map((e: any) => ({ v: String(e.extension_number || e.extension), l: ((e.extension_number || e.extension) + (e.display_name ? ' - ' + e.display_name : '')) })));
  const F = (k: string) => form[k] || '';
  const setF = (k: string, v: any) => setForm((f: any) => ({ ...f, [k]: v }));

  let title = '', subtitle = '', addLabel = '', addTitle = '', searchPh = '', empty = '';
  let columns: any[] = [];
  let modal: any = null;

  if (kind === 'extensions') {
    title = 'Extensions'; subtitle = 'Manage extensions on the ' + siteName + ' branch and assign display names.';
    addLabel = '+ Add Extension'; addTitle = 'Add Extension'; searchPh = 'Search extensions'; empty = 'No extensions yet';
    columns = [
      { key: 'ext', label: 'Extension', render: (e: any) => (
        <div><div className="z-tbl-primary-cell">{e.extension_number || e.extension}</div>
          <input className="z-inline-input" style={{ width: 150, marginTop: 4 }} value={e.display_name || ''} placeholder="Display name"
            onChange={(ev) => setRows((rs) => rs.map((x) => x.id === e.id ? { ...x, display_name: ev.target.value } : x))}
            onBlur={(ev) => patch(e, { display_name: ev.target.value })} /></div>
      ) },
      { key: 'calling', label: 'Calling', render: (e: any) => (
        <div style={{ display: 'flex', gap: 6 }}>
          <Pill on={!!e.webrtc_enabled} label="Web" onClick={() => patch(e, { webrtc_enabled: !e.webrtc_enabled })} />
          <Pill on={!!e.internal_call_enabled} label="Int" onClick={() => patch(e, { internal_call_enabled: !e.internal_call_enabled })} />
          <Pill on={!!e.external_call_enabled} label="Ext" onClick={() => patch(e, { external_call_enabled: !e.external_call_enabled })} />
        </div>
      ) },
      { key: 'status', label: 'Status', render: (e: any) => <StatusPill row={e} /> },
    ];
    modal = (
      <div className="z-field-grid">
        <ZoomField label="Extension Number"><input value={F('extension')} onChange={(e) => setF('extension', e.target.value)} placeholder="e.g. 8010" /></ZoomField>
        <ZoomField label="Display Name"><input value={F('display_name')} onChange={(e) => setF('display_name', e.target.value)} /></ZoomField>
        <ZoomField label="SIP Password" hint="Blank = auto-generate"><input value={F('password')} onChange={(e) => setF('password', e.target.value)} /></ZoomField>
      </div>
    );
  } else if (kind === 'dids') {
    title = 'Phone Numbers'; subtitle = 'Manage inbound DID routing to extensions, queues, or external forwarding on ' + siteName + '.';
    addLabel = '+ Add Number'; addTitle = 'Add Number (DID)'; searchPh = 'Search numbers'; empty = 'No numbers yet';
    columns = [
      { key: 'did', label: 'Number', render: (d: any) => <div className="z-tbl-primary-cell">{d.did_number}</div> },
      { key: 'provider', label: 'Provider', render: (d: any) => (
        <input className="z-inline-input" style={{ width: 120 }} value={d.provider_name || ''}
          onChange={(ev) => setRows((rs) => rs.map((x) => x.id === d.id ? { ...x, provider_name: ev.target.value } : x))}
          onBlur={(ev) => patch(d, { provider_name: ev.target.value })} />
      ) },
      { key: 'trunk', label: 'Trunk', render: (d: any) => (
        <input className="z-inline-input" style={{ width: 110 }} value={d.trunk_name || ''}
          onChange={(ev) => setRows((rs) => rs.map((x) => x.id === d.id ? { ...x, trunk_name: ev.target.value } : x))}
          onBlur={(ev) => patch(d, { trunk_name: ev.target.value })} />
      ) },
      { key: 'routing', label: 'Routing', render: (d: any) => (
        <select className="z-inline-select" value={d.routing_type || 'extension'} onChange={(ev) => patch(d, { routing_type: ev.target.value, destination_value: '' })}>
          <option value="extension">Extension</option><option value="queue">Queue</option><option value="external_forward">External Forward</option>
        </select>
      ) },
      { key: 'dest', label: 'Destination', render: (d: any) => (
        (d.routing_type === 'external_forward')
          ? <input className="z-inline-input" style={{ width: 140 }} value={d.destination_value || ''}
              onChange={(ev) => setRows((rs) => rs.map((x) => x.id === d.id ? { ...x, destination_value: ev.target.value } : x))}
              onBlur={(ev) => patch(d, { destination_value: ev.target.value })} />
          : <select className="z-inline-select" value={d.destination_value || ''} onChange={(ev) => patch(d, { destination_value: ev.target.value })}>
              <option value="">Select destination</option>
              {destOptions(d.routing_type || 'extension').map((o: any) => <option key={o.v} value={o.v}>{o.l}</option>)}
            </select>
      ) },
      { key: 'status', label: 'Status', render: (d: any) => <StatusPill row={d} /> },
    ];
    const rt = F('routing_type') || 'extension';
    modal = (
      <>
        <ZoomField label="DID Number"><input value={F('did_number')} onChange={(e) => setF('did_number', e.target.value)} placeholder="+97124942599" /></ZoomField>
        <div className="z-field-grid">
          <ZoomField label="Provider"><input value={F('provider_name')} onChange={(e) => setF('provider_name', e.target.value)} /></ZoomField>
          <ZoomField label="Trunk"><input value={F('trunk_name')} onChange={(e) => setF('trunk_name', e.target.value)} /></ZoomField>
        </div>
        <ZoomField label="Routing Type">
          <select value={rt} onChange={(e) => setForm((f: any) => ({ ...f, routing_type: e.target.value, destination_value: '' }))}>
            <option value="extension">Extension</option><option value="queue">Queue</option><option value="external_forward">External Forward</option>
          </select>
        </ZoomField>
        <ZoomField label="Destination">
          {rt === 'external_forward'
            ? <input value={F('destination_value')} onChange={(e) => setF('destination_value', e.target.value)} placeholder="External number" />
            : <select value={F('destination_value')} onChange={(e) => setF('destination_value', e.target.value)}>
                <option value="">Select destination</option>
                {destOptions(rt).map((o: any) => <option key={o.v} value={o.v}>{o.l}</option>)}
              </select>}
        </ZoomField>
      </>
    );
  } else if (kind === 'trunks') {
    title = 'Trunks'; subtitle = 'SIP trunks / gateways that carry calls for the ' + siteName + ' branch.';
    addLabel = '+ Add Trunk'; addTitle = 'Add Trunk'; searchPh = 'Search trunks'; empty = 'No trunks yet';
    columns = [
      { key: 'trunk', label: 'Trunk', render: (t: any) => (
        <div><div className="z-tbl-primary-cell">{t.display_name || t.trunk_name}</div><div className="z-tbl-sub">{t.sip_host}:{t.sip_port || 5060}</div></div>
      ) },
      { key: 'auth', label: 'Auth User', render: (t: any) => t.auth_username || <span className="z-tbl-sub">IP auth</span> },
      { key: 'transport', label: 'Transport', render: (t: any) => (t.transport || 'udp').toUpperCase() },
      { key: 'codecs', label: 'Codecs', render: (t: any) => <span className="z-tbl-sub">{t.codecs || 'ulaw,alaw'}</span> },
      { key: 'status', label: 'Status', render: (t: any) => <StatusPill row={t} /> },
    ];
    modal = (
      <>
        <div className="z-field-grid">
          <ZoomField label="Trunk Name" hint="Internal name, e.g. pstn-auh"><input value={F('trunk_name')} onChange={(e) => setF('trunk_name', e.target.value)} /></ZoomField>
          <ZoomField label="Display Name"><input value={F('display_name')} onChange={(e) => setF('display_name', e.target.value)} /></ZoomField>
        </div>
        <div className="z-field-grid">
          <ZoomField label="Gateway / SBC IP"><input value={F('sip_host')} onChange={(e) => setF('sip_host', e.target.value)} placeholder="e.g. 10.0.0.1" /></ZoomField>
          <ZoomField label="Port"><input value={F('sip_port')} onChange={(e) => setF('sip_port', e.target.value)} placeholder="5060" /></ZoomField>
        </div>
        <div className="z-field-grid">
          <ZoomField label="Auth User" hint="Blank = IP auth"><input value={F('auth_username')} onChange={(e) => setF('auth_username', e.target.value)} /></ZoomField>
          <ZoomField label="Auth Password"><input value={F('auth_password')} onChange={(e) => setF('auth_password', e.target.value)} /></ZoomField>
        </div>
        <div className="z-field-grid">
          <ZoomField label="Transport"><select value={F('transport') || 'udp'} onChange={(e) => setF('transport', e.target.value)}><option value="udp">UDP</option><option value="tcp">TCP</option><option value="tls">TLS</option></select></ZoomField>
          <ZoomField label="Codecs"><input value={F('codecs')} onChange={(e) => setF('codecs', e.target.value)} placeholder="ulaw,alaw" /></ZoomField>
        </div>
        <ZoomField label="Context" hint="Dialplan context for inbound"><input value={F('context')} onChange={(e) => setF('context', e.target.value)} placeholder="ce-from-pstn" /></ZoomField>
      </>
    );
  } else {
    title = 'Call Queues'; subtitle = 'Create queues and ring strategies for the ' + siteName + ' branch.';
    addLabel = '+ Add Queue'; addTitle = 'Add Call Queue'; searchPh = 'Search queues'; empty = 'No queues yet';
    const STRATS = [['ringall', 'Ring All'], ['round_robin', 'Round Robin'], ['leastrecent', 'Least Recent'], ['fewestcalls', 'Fewest Calls'], ['random', 'Random']];
    columns = [
      { key: 'q', label: 'Queue', render: (q: any) => (
        <div><div className="z-tbl-primary-cell">{q.display_name || q.queue_name}</div><div className="z-tbl-sub">{q.queue_name}</div></div>
      ) },
      { key: 'strategy', label: 'Ring Strategy', render: (q: any) => (
        <select className="z-inline-select" value={q.strategy || 'ringall'} onChange={(ev) => patch(q, { strategy: ev.target.value })}>
          {STRATS.map((st) => <option key={st[0]} value={st[0]}>{st[1]}</option>)}
        </select>
      ) },
      { key: 'priority', label: 'Priority', render: (q: any) => (
        <input className="z-inline-input" style={{ width: 64 }} type="number" value={q.priority ?? 1}
          onChange={(ev) => setRows((rs) => rs.map((x) => x.id === q.id ? { ...x, priority: ev.target.value } : x))}
          onBlur={(ev) => patch(q, { priority: Number(ev.target.value) })} />
      ) },
      { key: 'members', label: 'Members', render: (q: any) => (
        <input className="z-inline-input" style={{ width: 150 }} value={q.members || ''} placeholder="exts, comma-sep"
          onChange={(ev) => setRows((rs) => rs.map((x) => x.id === q.id ? { ...x, members: ev.target.value } : x))}
          onBlur={(ev) => patch(q, { members: ev.target.value })} />
      ) },
      { key: 'status', label: 'Status', render: (q: any) => <StatusPill row={q} /> },
    ];
    modal = (
      <>
        <ZoomField label="Queue Name" hint="Internal name, e.g. support"><input value={F('queue_name')} onChange={(e) => setF('queue_name', e.target.value)} placeholder="support" /></ZoomField>
        <ZoomField label="Display Name"><input value={F('display_name')} onChange={(e) => setF('display_name', e.target.value)} placeholder="Support Team" /></ZoomField>
        <div className="z-field-grid">
          <ZoomField label="Ring Strategy"><select value={F('strategy') || 'ringall'} onChange={(e) => setF('strategy', e.target.value)}>{STRATS.map((st) => <option key={st[0]} value={st[0]}>{st[1]}</option>)}</select></ZoomField>
          <ZoomField label="Priority"><input type="number" value={F('priority') || 1} onChange={(e) => setF('priority', e.target.value)} /></ZoomField>
        </div>
        <ZoomField label="Members" hint="Extensions, comma-separated"><input value={F('members')} onChange={(e) => setF('members', e.target.value)} placeholder="8010,8011" /></ZoomField>
      </>
    );
  }

  const qy = search.trim().toLowerCase();
  const filtered = !qy ? rows : rows.filter((r: any) => JSON.stringify(r).toLowerCase().includes(qy));

  return (
    <>
      <div style={{ margin: '2px 0 14px', fontSize: 13, color: '#5b5ef0', background: '#eef0fe', display: 'inline-block', padding: '4px 12px', borderRadius: 999, fontWeight: 600 }}>
        {siteName} branch — changes push to the branch server automatically.
      </div>
      {showAdd && (
        <ZoomModal title={addTitle} onClose={() => { setShowAdd(false); setMsg(''); }}
          footer={<><ZoomBtn onClick={() => { setShowAdd(false); setMsg(''); }}>Cancel</ZoomBtn><ZoomBtn variant="primary" onClick={create}>Add</ZoomBtn></>}>
          {modal}
          {msg && <div style={{ marginTop: 10, color: '#c0392b', fontSize: 13 }}>{msg}</div>}
        </ZoomModal>
      )}
      <ZoomTable
        title={title}
        subtitle={subtitle}
        search={search}
        onSearch={setSearch}
        searchPlaceholder={searchPh}
        actions={<ZoomBtn variant="primary" onClick={() => { setForm({}); setMsg(''); setShowAdd(true); }}>{addLabel}</ZoomBtn>}
        columns={columns}
        rows={filtered}
        rowKey={(r: any) => r.id}
        rowActions={(r: any) => <ZoomBtn variant="danger" onClick={() => del(r)}>Delete</ZoomBtn>}
        emptyText={empty}
      />
    </>
  );
}

export default function AdminPanel({ user, onLogout }: any) {
  const [activePage, setActivePage] = useState('Dashboard');
  // other screens can open a page (e.g. Call handling → Call Flows of a user's number)
  useEffect(() => {
    const h = (e: any) => { if (e && typeof e.detail === 'string') setActivePage(e.detail); };
    window.addEventListener('ce-open-page', h);
    return () => window.removeEventListener('ce-open-page', h);
  }, []);
  const isSA = !!(user?.role === 'super_admin' || user?.is_admin);
  // Zoom-style console pages (Users/Queues/DIDs) — enabled for all tenants + super admin.
  const useZoom = true;
  // Same props contract — only the presentation differs, so functionality is identical.
  const UsersComp: any = useZoom ? ZoomUsersPage : UsersPage;
  const QueuesComp: any = useZoom ? ZoomQueuesPage : QueuesPage;

  const [users, setUsers] = useState<AdminUser[]>([]);
  const [userGroups, setUserGroups] = useState<UserGroup[]>([]);
  const [queues, setQueues] = useState<Queue[]>([]);
  const [tenants, setTenants] = useState<Tenant[]>([]);
  const [newTenantName, setNewTenantName] = useState('');
  const [newTenantCompany, setNewTenantCompany] = useState('');
  const [newTenantDomain, setNewTenantDomain] = useState('');
  const [newTenantEmail, setNewTenantEmail] = useState('');
  const [newTenantMaxUsers, setNewTenantMaxUsers] = useState(50);
  const [newTenantAdminUsername, setNewTenantAdminUsername] = useState('');
  const [newTenantAdminPassword, setNewTenantAdminPassword] = useState('');
  const [queueMembers, setQueueMembers] = useState<QueueMember[]>([]);
  const [selectedQueue, setSelectedQueue] = useState<Queue | null>(null);


  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');
  const [trunks, setTrunks] = useState<any[]>([]);

  const [newUsername, setNewUsername] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newFirstName, setNewFirstName] = useState('');
  const [newLastName, setNewLastName] = useState('');
  const [newEmail, setNewEmail] = useState('');
  const [newDepartment, setNewDepartment] = useState('');
  const [newJobTitle, setNewJobTitle] = useState('');
  const [newLocation, setNewLocation] = useState('');
  const [newExtension, setNewExtension] = useState('');
  const [siteCtx, setSiteCtx] = useState('central');
  const [branchSites, setBranchSites] = useState<any[]>([]);
  // Central PBX sites (pbx_sites): picking one in the switcher filters Users /
  // Extensions / DIDs to that site and pre-selects it in Add User.
  const [pbxSites, setPbxSites] = useState<any[]>([]);
  useEffect(() => { (api as any).getPbxSites().then((d: any) => setPbxSites(d.sites || [])).catch(() => {}); }, []);
  const cust = useCustomer();
  useEffect(() => { loadCustomers(); }, []);
  const pbxSite = String(siteCtx).startsWith('pbx:') ? (pbxSites.find((s: any) => 'pbx:' + s.id === String(siteCtx)) || null) : null;
  const inPbxSite = (ext: any) => extInSite(ext, pbxSite);
  const openSite = (siteId: any, page: string) => { setSiteCtx('pbx:' + siteId); setActivePage(page); };
  useEffect(() => {
    const t = localStorage.getItem('token'); if (!t) return;
    Promise.all([
      fetch('/api/v1/admin/sites', { headers: { Authorization: 'Bearer ' + t } }).then((r) => r.ok ? r.json() : []),
      fetch('/api/v1/admin/edges', { headers: { Authorization: 'Bearer ' + t } }).then((r) => r.ok ? r.json() : []),
    ]).then(([sites, edges]) => {
      const m = new Set((edges || []).filter((e: any) => e.management_mode === 'managed').map((e: any) => e.site_id));
      setBranchSites((sites || []).filter((x: any) => m.has(x.id)));
    }).catch(() => {});
  }, []);
  const branchName = (siteCtx === 'central' || String(siteCtx).startsWith('pbx:')) ? 'Central' : ((branchSites.find((s: any) => String(s.id) === String(siteCtx)) || {}).name || 'Branch');
  const [branchUsers, setBranchUsers] = useState<any[]>([]);
  const loadBranchUsers = () => {
    const t = localStorage.getItem('token');
    if (!t || siteCtx === 'central' || String(siteCtx).startsWith('pbx:')) { setBranchUsers([]); return; }
    fetch('/api/v1/admin/sites/' + siteCtx + '/extensions', { headers: { Authorization: 'Bearer ' + t } })
      .then((r) => (r.ok ? r.json() : [])).then(setBranchUsers).catch(() => setBranchUsers([]));
  };
  useEffect(() => { loadBranchUsers(); }, [siteCtx]); // eslint-disable-line react-hooks/exhaustive-deps
  const branchDeleteUser = async (u: any) => {
    if (!window.confirm('Remove ' + (u.username || u.extension) + ' from the ' + branchName + ' branch server?')) return;
    const t = localStorage.getItem('token');
    await fetch('/api/v1/admin/sites/' + siteCtx + '/extensions/' + u.id, { method: 'DELETE', headers: { Authorization: 'Bearer ' + t } });
    loadBranchUsers();
  };
  const branchUpdateUser = async (u: any, changes: any) => {
    const t = localStorage.getItem('token');
    await fetch('/api/v1/admin/sites/' + siteCtx + '/extensions/' + u.id, { method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + t }, body: JSON.stringify(changes || {}) });
    loadBranchUsers();
  };
  const branchResetPassword = async (u: any, pw: string) => {
    const t = localStorage.getItem('token');
    await fetch('/api/v1/admin/sites/' + siteCtx + '/extensions/' + u.id, { method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + t }, body: JSON.stringify({ password: pw }) });
    loadBranchUsers();
  };

  const [newQueueName, setNewQueueName] = useState('');
  const [newQueueDisplayName, setNewQueueDisplayName] = useState('');
  const [newQueueStrategy, setNewQueueStrategy] = useState('round_robin');
  const [newQueuePriority, setNewQueuePriority] = useState(1);

  const loadUsers = async () => {
    try {
      const data = await api.getAdminUsers();
      setUsers(data);
      try {
        const groups = await api.get('/api/admin-panel/user-groups');
        setUserGroups(groups.data || []);
      } catch (_) {}
    } catch (e) {
      console.error(e);
      setStatus('Failed to load users');
    }
  };

  const loadQueues = async () => {
    try {
      const data = await api.getQueues();
      setQueues(data);
    } catch (e: any) {
      console.error(e);
      // a group without the Queues pages (e.g. Operations) is simply not allowed to list them — no error banner
      if (e?.response?.status !== 403 && !/not available/i.test(String(e?.message || ''))) setStatus('Failed to load queues');
    }
  };

  const loadQueueMembers = async (q: Queue) => {
    try {
      setSelectedQueue(q);
      const data = await api.getQueueMembers(q.id);
      setQueueMembers(data);
    } catch (e) {
      console.error(e);
      alert('Failed to load queue members');
    }
  };
  const loadTenants = async () => {
    try {
      const data = await api.getTenants();
      setTenants(data);
    } catch (e) {
      console.error(e);
      setStatus('Failed to load tenants');
    }
  };
  useEffect(() => {
    loadUsers();
    loadQueues();
    loadTenants();
    (api as any).getTrunks().then((data: any) => setTrunks(data || [])).catch(() => {});
  }, []);


  const createUser = async (extra?: any) => {
    const ex = (extra && typeof extra === 'object' && !('nativeEvent' in extra)) ? extra : {};
    if (!newUsername.trim() || !newPassword.trim()) {
      alert('Username and password required');
      return;
    }

    try {
      const created: any = await api.createAdminUser({
        username: newUsername.trim(),
        password: newPassword.trim(),
        role: 'pbx_user',
        user_type: 'pbx',
        cc_enabled: false,
        queue_enabled: false,
        supervisor_enabled: false,
        is_admin: false,
        feature_recording: true,
        feature_contacts: true,
        feature_from_number: true,
        feature_recent_calls: true,
        feature_settings: true,
        feature_transfer: true,
        feature_queue_mode: true,
        feature_supervisor: false,
        feature_wallboard: false,
        feature_crm_popup: true,
        feature_ai_transcription: false,
        first_name: newFirstName.trim(),
        last_name: newLastName.trim(),
        email: newEmail.trim(),
        department: newDepartment.trim(),
        job_title: newJobTitle.trim(),
        location: newLocation.trim(),
        extension_number: newExtension.trim() || undefined,
        ...ex
      });

      setNewUsername('');
      setNewPassword('');
      setNewFirstName('');
      setNewLastName('');
      setNewEmail('');
      setNewDepartment('');
      setNewJobTitle('');
      setNewLocation('');
      setNewExtension('');
      setStatus('User created successfully'
        + (created?.site ? ' at ' + created.site : '')
        + (created?.extension_number ? ' - ext ' + created.extension_number : '')
        + (created?.did?.did_number && !created?.did?.error ? ', DID ' + created.did.did_number : '')
        + (created?.gateway ? ', dials out via ' + created.gateway : ''));
      if (created?.did?.error) alert('User created, but the DID was not assigned: ' + created.did.error);
      await loadUsers();
    } catch (e: any) {
      console.error(e);
      alert(e?.response?.data?.error || 'Failed to create user');
    }
  };

  const updateUser = async (u: AdminUser, changes: Partial<AdminUser>) => {
    const updated = { ...u, ...changes };

    try {
      await api.updateAdminUser(u.id, {
        role: updated.role || 'pbx_user',
        user_type: updated.user_type || 'pbx',
        cc_enabled: !!updated.cc_enabled,
        queue_enabled: !!updated.queue_enabled,
        supervisor_enabled: !!updated.supervisor_enabled,
        is_active: !!updated.is_active,
        is_admin: !!updated.is_admin,
        feature_recording: !!updated.feature_recording,
        feature_contacts: !!updated.feature_contacts,
        feature_from_number: !!updated.feature_from_number,
        feature_recent_calls: !!updated.feature_recent_calls,
        feature_settings: !!updated.feature_settings,
        feature_transfer: !!updated.feature_transfer,
        feature_queue_mode: !!updated.feature_queue_mode,
        feature_supervisor: !!updated.feature_supervisor,
        feature_wallboard: !!updated.feature_wallboard,
        feature_crm_popup: !!updated.feature_crm_popup,
        feature_ai_transcription: !!updated.feature_ai_transcription,
        ai_agent_enabled: !!updated.ai_agent_enabled,
        voice_bot_enabled: !!updated.voice_bot_enabled,
        first_name:  updated.first_name  ?? undefined,
        last_name:   updated.last_name   ?? undefined,
        department:  updated.department  ?? undefined,
        job_title:   updated.job_title   ?? undefined,
        location:    updated.location    ?? undefined,
        email:       updated.email       ?? undefined,
        manager_id:  updated.manager_id  ?? undefined,
      });
      // Mobile app access has its own endpoint (signs out the app + drops push/SIP mobile account when off)
      const _mobNow = Number(updated.mobile_app_allowed ?? 1), _mobWas = Number(u.mobile_app_allowed ?? 1);
      if (_mobNow !== _mobWas) await axios.put(`/api/admin-panel/users/${u.id}/mobile-app`, { allowed: _mobNow === 1 });

      await loadUsers();
    } catch (e: any) {
      console.error(e);
      alert(e?.response?.data?.error || 'Failed to update user');
    }
  };

  const resetPassword = async (u: AdminUser, providedPassword?: string) => {
    const password = providedPassword ?? prompt(`Enter new password for ${u.username}`);
    if (!password) return;

    try {
      await api.resetAdminUserPassword(u.id, password);
      if (!providedPassword) alert('Password updated');
    } catch (e: any) {
      console.error(e);
      alert(e?.response?.data?.error || 'Failed to reset password');
    }
  };

  const deleteUser = async (u: AdminUser) => {
    if (!window.confirm(`Delete ${u.username}?`)) return;

    try {
      await api.deleteAdminUser(u.id);
      await loadUsers();
    } catch (e: any) {
      console.error(e);
      alert(e?.response?.data?.error || 'Failed to delete user');
    }
  };

  const createQueue = async () => {
    if (!newQueueName.trim()) {
      alert('Queue name required');
      return;
    }

    try {
      await api.createQueue({
        queue_name: withPrefix(cust.prefix, newQueueName.trim()),
        display_name: newQueueDisplayName.trim() || newQueueName.trim(),
        customer_id: cust.customerId || undefined,
        strategy: newQueueStrategy,
        priority: Number(newQueuePriority || 1),
        is_active: true
      });

      setNewQueueName('');
      setNewQueueDisplayName('');
      setNewQueueStrategy('round_robin');
      setNewQueuePriority(1);
      setStatus('Queue created successfully');
      loadCustomers();
      await loadQueues();
    } catch (e: any) {
      console.error(e);
      alert(e?.response?.data?.error || 'Failed to create queue');
    }
  };

  const updateQueue = async (q: Queue, changes: Partial<Queue>) => {
    const updated = { ...q, ...changes };

    try {
      await api.updateQueue(q.id, {
        display_name: updated.display_name,
        strategy: updated.strategy,
        priority: Number(updated.priority || 1),
        is_active: !!updated.is_active
      });

      await loadQueues();

      if (selectedQueue?.id === q.id) {
        setSelectedQueue({ ...updated });
      }
    } catch (e: any) {
      console.error(e);
      alert(e?.response?.data?.error || 'Failed to update queue');
    }
  };

  const deleteQueue = async (q: Queue) => {
    if (!window.confirm(`Delete queue ${q.queue_name}?`)) return;

    try {
      await api.deleteQueue(q.id);
      if (selectedQueue?.id === q.id) {
        setSelectedQueue(null);
        setQueueMembers([]);
      }
      await loadQueues();
    } catch (e: any) {
      console.error(e);
      alert(e?.response?.data?.error || 'Failed to delete queue');
    }
  };
  const createTenant = async () => {
    if (!newTenantName.trim()) {
      alert('Tenant name is required');
      return;
    }
    if (!newTenantAdminUsername.trim()) {
      alert('Tenant admin username is required');
      return;
    }
    if (!newTenantAdminPassword.trim() || newTenantAdminPassword.trim().length < 6) {
      alert('Tenant admin password is required (minimum 6 characters)');
      return;
    }

    try {
      await api.createTenant({
        tenant_name: newTenantName.trim(),
        company_name: newTenantCompany.trim() || newTenantName.trim(),
        domain_name: newTenantDomain.trim() || null,
        contact_email: newTenantEmail.trim() || null,
        max_users: Number(newTenantMaxUsers || 50),
        extension_base: Number((document.getElementById('newTenantExtBase') as HTMLInputElement)?.value || 1000),
        is_active: true,
        admin_username: newTenantAdminUsername.trim(),
        admin_password: newTenantAdminPassword.trim(),
        lic_pbx_users:      Number((document.getElementById('newTenantLicPbx')      as HTMLInputElement)?.value || 0),
        lic_contact_centre: Number((document.getElementById('newTenantLicCC')       as HTMLInputElement)?.value || 0),
        lic_ai_agent:       Number((document.getElementById('newTenantLicAI')       as HTMLInputElement)?.value || 0),
        lic_voice_bot:      Number((document.getElementById('newTenantLicVB')       as HTMLInputElement)?.value || 0),
        lic_supervisor:     Number((document.getElementById('newTenantLicSup')      as HTMLInputElement)?.value || 0),
      });

      setNewTenantName('');
      setNewTenantCompany('');
      setNewTenantDomain('');
      setNewTenantEmail('');
      setNewTenantMaxUsers(50);
      setNewTenantAdminUsername('');
      setNewTenantAdminPassword('');

      setStatus('Tenant created successfully');
      await loadTenants();
    } catch (e: any) {
      console.error(e);
      alert(e?.response?.data?.error || 'Failed to create tenant');
    }
  };

  const updateTenant = async (t: Tenant, changes: Partial<Tenant>) => {
    const updated = { ...t, ...changes };

    try {
      await api.updateTenant(t.id, {
        company_name: updated.company_name || '',
        domain_name: updated.domain_name || '',
        contact_email: updated.contact_email || '',
        max_users: Number(updated.max_users || 50),
        extension_base: Number(updated.extension_base || 1000),
        is_active: !!updated.is_active,
        primary_trunk_id: (updated as any).primary_trunk_id ?? null,
        outbound_limit_enabled: updated.outbound_limit_enabled ? 1 : 0,
        outbound_limit_minutes: Number(updated.outbound_limit_minutes || 0)
      });

      await loadTenants();
    } catch (e: any) {
      console.error(e);
      alert(e?.response?.data?.error || 'Failed to update tenant');
    }
  };
  const addMember = async (agent: AdminUser) => {
    if (!selectedQueue) return;

    try {
      await api.addQueueMember(selectedQueue.id, {
        user_id: agent.id,
        penalty: 0,
        is_active: true
      });

      await loadQueueMembers(selectedQueue);
    } catch (e: any) {
      console.error(e);
      alert(e?.response?.data?.error || 'Failed to add member');
    }
  };

  const removeMember = async (m: QueueMember) => {
    if (!selectedQueue) return;

    try {
      await api.removeQueueMember(selectedQueue.id, m.user_id);
      await loadQueueMembers(selectedQueue);
    } catch (e: any) {
      console.error(e);
      alert(e?.response?.data?.error || 'Failed to remove member');
    }
  };

  // 2026-10-28: search also matches name, extension, e-mail, department and customer (company) name
  // 2026-10-30: … and the user's direct numbers, typed in any form (+971 2…, 02…, spaces, last digits)
  const _uq = search.trim().toLowerCase();
  const _qd = _uq.replace(/[^0-9]/g, '');
  const didHit = (dids: any) => _qd.length >= 3 && (dids || []).some((d: string) => {
    const dd = String(d).replace(/[^0-9]/g, ''); const local = dd.startsWith('971') ? '0' + dd.slice(3) : dd;
    return dd.includes(_qd) || local.includes(_qd);
  });
  const filteredUsers = users.filter((u) => {
    const x: any = u;
    const hay = !_uq ? '' : [x.username, x.first_name, x.last_name, [x.first_name, x.last_name].filter(Boolean).join(' '), x.extension_number, x.email, x.department,
      (x.dids || []).join(' '), cust.nameOf ? cust.nameOf(cust.tagOf('user', u.id)) : ''].filter(Boolean).join(' ').toLowerCase();
    return (!_uq || hay.includes(_uq) || didHit(x.dids)) && inPbxSite(x.extension_number) && cust.match('user', u.id);
  });

  const ccAgents = users.filter((u) => !!u.cc_enabled);
  const memberIds = new Set(queueMembers.map((m) => m.user_id));
  const availableAgents = ccAgents.filter((u) =>
    !memberIds.has(u.id) &&
    (!selectedQueue || !u.tenant_id || !selectedQueue.tenant_id || u.tenant_id === selectedQueue.tenant_id)
  );

  return (
    <AdminShell
      user={user}
      onLogout={onLogout}
      active={activePage}
      setActive={setActivePage}
    >
      {status && <div className="admin-alert">{status}</div>}
      {isViewOnlySession() && <div className="admin-alert" style={{ background: '#eef4ff', borderColor: '#bcd3ff', color: '#1f3b73' }}>View-only access — you can view everything and run billing reports{viewOnlyGreetings() ? ' and upload or edit greetings & recordings' : ''}, but other changes are disabled for your group.</div>}
      <SiteBar siteCtx={siteCtx} setSiteCtx={setSiteCtx} branchSites={branchSites} pbxSites={pbxSites} />
      {(siteCtx === 'central' || String(siteCtx).startsWith('pbx:')) ? (<>

      {activePage === 'Dashboard' && (<>
        <ServerHealthPanel onOpen={() => setActivePage('Health Check')} />
        <DashboardPage
          users={users}
          queues={queues}
          user={user}
        />
        {!isOpsSession() && <OpsActivityCard />}
        {user?.role === 'tenant_admin' && <div style={{ marginTop: 18 }}><SubAdminWallboard fallback={null} /></div>}
      </>)}

      {activePage === 'Tenants' && (
        <TenantsPage
          tenants={tenants}
          newTenantName={newTenantName}
          setNewTenantName={setNewTenantName}
          newTenantCompany={newTenantCompany}
          setNewTenantCompany={setNewTenantCompany}
          newTenantDomain={newTenantDomain}
          setNewTenantDomain={setNewTenantDomain}
          newTenantEmail={newTenantEmail}
          setNewTenantEmail={setNewTenantEmail}
          newTenantMaxUsers={newTenantMaxUsers}
          setNewTenantMaxUsers={setNewTenantMaxUsers}
          newTenantAdminUsername={newTenantAdminUsername}
          setNewTenantAdminUsername={setNewTenantAdminUsername}
          newTenantAdminPassword={newTenantAdminPassword}
          setNewTenantAdminPassword={setNewTenantAdminPassword}
          createTenant={createTenant}
          updateTenant={updateTenant}
          trunks={trunks}
        />
      )}

      {activePage === 'Licenses' && <LicensesPage user={user} />}

      {activePage === 'Tenant Branding' && (
        <TenantBrandingPage tenants={tenants} user={user} />
      )}

      {activePage === 'User Groups' && <UserGroupsPage userGroups={userGroups} users={users} onRefresh={loadUsers} />}
      {activePage === 'Company Directory' && <DirectoryPage />}
      {activePage === 'External Contacts' && <ExternalContactsPage />}
      {activePage === 'Users' && (
        <UsersComp
          userGroups={userGroups}
          users={filteredUsers}
          search={search}
          setSearch={setSearch}
          newUsername={newUsername}
          setNewUsername={setNewUsername}
          newFirstName={newFirstName}
          setNewFirstName={setNewFirstName}
          newLastName={newLastName}
          setNewLastName={setNewLastName}
          newEmail={newEmail}
          setNewEmail={setNewEmail}
          newDepartment={newDepartment}
          setNewDepartment={setNewDepartment}
          newJobTitle={newJobTitle}
          setNewJobTitle={setNewJobTitle}
          newLocation={newLocation}
          setNewLocation={setNewLocation}
          newExtension={newExtension}
          setNewExtension={setNewExtension}
          newPassword={newPassword}
          setNewPassword={setNewPassword}
          createUser={createUser}
          updateUser={updateUser}
          resetPassword={resetPassword}
          deleteUser={deleteUser}
          tenants={tenants}
          showTenantSelector={isSA}
          presetSiteId={pbxSite ? String(pbxSite.id) : ''}
        />
      )}
      {activePage === 'Extensions' && (
        <ExtensionsPage showTenantSelector={isSA} zoom={useZoom} site={pbxSite} />
      )}
      {activePage === 'Voice Bots' && (
        <VoiceBotsPage tenants={tenants} showTenantSelector={isSA} zoom={useZoom} />
      )}


      {activePage === 'DIDs' && (
        <DidsPage showTenantSelector={isSA} zoom={useZoom} site={pbxSite} />
      )}

      {activePage === 'Trunks' && (
        <TrunksPage user={user} />
      )}
      {activePage === 'Telephony Engine' && (
        <AsteriskPage />
      )}
      {activePage === 'Deploy to Production' && <DeployToProductionPage user={user} />}

      {activePage === 'Ops Knowledge Base' && (
        <OpsKnowledgeBase />
      )}
      {activePage === 'Customers' && <CustomersPage />}
      {activePage === 'Reception Settings' && <ReceptionSettingsPage />}
      {activePage === 'Speed Dials' && <SpeedDialsPage />}
      {activePage === 'Voicemail' && <VoicemailPage site={pbxSite} />}
      {activePage === 'IVR Menus' && <IvrMenusPage site={pbxSite} />}
      {activePage === 'Business Hours' && <BusinessHoursPage site={pbxSite} />}
      {activePage === 'Queues' && (
        <QueuesComp
          reloadQueues={loadQueues}
          queues={queues}
          selectedQueue={selectedQueue}
          queueMembers={queueMembers}
          availableAgents={availableAgents}
          newQueueName={newQueueName}
          setNewQueueName={setNewQueueName}
          newQueueDisplayName={newQueueDisplayName}
          setNewQueueDisplayName={setNewQueueDisplayName}
          newQueueStrategy={newQueueStrategy}
          setNewQueueStrategy={setNewQueueStrategy}
          newQueuePriority={newQueuePriority}
          setNewQueuePriority={setNewQueuePriority}
          createQueue={createQueue}
          updateQueue={updateQueue}
          deleteQueue={deleteQueue}
          loadQueueMembers={loadQueueMembers}
          addMember={addMember}
          removeMember={removeMember}
          tenants={tenants}
          showTenantSelector={isSA}
        />
      )}
      {activePage === 'Agent State' && (
        <>
          <div className="admin-page-title">
            Agent State
          </div>

          <div className="admin-page-subtitle">
            Manage realtime queue and pause state.
          </div>

          <AgentStatePanel />
        </>
      )}
      {activePage === 'Supervisor Monitor' && (
        <SupervisorMonitor zoom={useZoom} />
      )}
      {activePage === 'Queue Monitor' && (
        <QueueMonitor />
      )}
      {activePage === 'Live Calls' && (
        <LiveCalls />
      )}
      {activePage === 'Banned IPs' && (
        <SecurityBans />
      )}
      {activePage === 'DID Inventory' && isSA && (
        <DidInventoryPage />
      )}
      {activePage === 'Call Flows' && <CallFlowsPage />}
      {(activePage === 'Health Check' || activePage === 'Security Monitoring') && (
        <HealthCheckPage view={activePage === 'Security Monitoring' ? 'security' : 'health'} onSwitch={setActivePage} />
      )}
      {activePage === 'Gateway Management' && (isSA || user?.role === 'pbx_admin') && (
        <GatewayManagementPage />
      )}
      {activePage === 'SBC Management' && (isSA || user?.role === 'pbx_admin') && (
        <SbcManagementPage />
      )}
      {activePage === 'Greetings' && <RecordingsLibraryPage />}
      {activePage === 'Call Records' && (
        <CdrPage />
      )}
      {activePage === 'Sites' && <PbxSitesPage onOpen={openSite} />}
      {activePage === 'AI Sales Agent' && (
        <SalesAgentPage user={user} />
      )}
      {activePage === 'Wallboard' && (user?.role === 'pbx_admin' ? <SubAdminWallboard fallback={<Wallboard />} /> : <>
        <Wallboard />
        {!isOpsSession() && <OpsActivityCard />}
      </>)}
      {activePage === 'Operations Team' && <OperationsTeamPage />}

      {activePage === 'Reports' && (
        <ReportsPage adminTenantOverride={user?.is_admin ? undefined : user?.tenant_id} />
      )}

      {activePage === 'Phones' && <PhonesPage user={user} />}

      {activePage === 'AI Conversations' && <AIConversations />}
      {activePage === 'AI Knowledge Base' && <AIKnowledgeBase />}
      {activePage === 'AI Queue Assistant' && <QueueAIManagement user={user} />}
      {activePage === 'AI Reports' && <AIReports />}
      {activePage === 'AI Settings' && <AISettings />}
      {activePage === 'Call Transcripts' && <TranscriptsListPage />}
      {activePage === 'Transcript Search' && <TranscriptSearch />}
      {activePage === 'Transcription Admin' && <TranscriptionAdmin user={user} />}
      {activePage === 'WhatsApp' && <WhatsAppSettings />}

      {activePage === 'Teams Settings' && <TeamsSettingsPage user={user} />}
      {activePage === 'Teams Contacts' && <TeamsContactsPage user={user} />}
      {activePage === 'Teams Admin' && <TeamsAdminPage user={user} />}
      {activePage === 'Demo Platform' && <DemoManagement />}
            {(['Billing Dashboard','Billing Accounts','Rate Plans','Invoices','Billing Reports','Carriers & LCR','Packages & Bundles','DID Billing','Reseller Billing','Revenue Assurance','Tax Settings'].includes(activePage)) && (
        <BillingPage user={user} tab={activePage} siteId={pbxSite ? String(pbxSite.id) : ''} />
      )}
      {activePage === 'Security' && <SecurityPage user={user} />}
      {activePage === 'Pickup Groups' && <PickupGroupsAdmin user={user} tenants={tenants} />}
      {activePage === 'CRM Integrations' && <CRMIntegrationsPage user={user} tenants={tenants} />}
      {activePage === 'CRM Dashboard' && <CRMDashboard user={user} tenants={tenants} />}
      {activePage === 'CRM Queue Mapping' && <CRMQueueMappingPage user={user} tenants={tenants} />}
      {activePage === 'CRM Field Mapping' && <CRMFieldMappingPage user={user} tenants={tenants} />}

      {activePage === 'Settings' && <SettingsPage user={user} tenants={tenants} />}
      {activePage === 'Dialing Policy' && <DialingPolicyPage user={user} />}
      {activePage === 'Call Trace' && <CallTracePage />}
      {activePage === 'Edge Servers' && (
        <iframe
          title="Edge Servers"
          src="/api/v1/console"
          style={{ width: '100%', height: 'calc(100vh - 140px)', border: 0, borderRadius: 10, background: '#fff' }}
        />
      )}
      {activePage === 'Calling Bundles' && <BundlesPage user={user} />}
      {activePage === 'Menu Access' && <MenuAccessPage user={user} />}
      {activePage === 'Managed Tenants' && <ManagedTenantsPage user={user} />}
      </>) : (
        activePage === 'Users'
          ? <ZoomUsersPage
              userGroups={userGroups}
              users={branchUsers}
              search={search} setSearch={setSearch}
              newUsername={newUsername} setNewUsername={setNewUsername}
              newFirstName={newFirstName} setNewFirstName={setNewFirstName}
              newLastName={newLastName} setNewLastName={setNewLastName}
              newEmail={newEmail} setNewEmail={setNewEmail}
              newDepartment={newDepartment} setNewDepartment={setNewDepartment}
              newJobTitle={newJobTitle} setNewJobTitle={setNewJobTitle}
              newLocation={newLocation} setNewLocation={setNewLocation}
              newExtension={newExtension} setNewExtension={setNewExtension}
              newPassword={newPassword} setNewPassword={setNewPassword}
              createUser={createUser} updateUser={branchUpdateUser}
              resetPassword={branchResetPassword} deleteUser={branchDeleteUser}
              tenants={tenants} showTenantSelector={false}
              forceSite={String(siteCtx)} onBranchChanged={loadBranchUsers}
            />
          : (['Extensions', 'DIDs', 'Trunks', 'Queues'].indexOf(activePage) >= 0)
            ? <BranchScreen kind={activePage.toLowerCase()} siteId={siteCtx} siteName={branchName} />
            : activePage === 'Dialing Policy'
              ? <BranchDialingPolicy siteId={siteCtx} siteName={branchName} />
              : activePage === 'Voice Bots'
                ? <BranchCentralOnly title="Auto Receptionist" siteName={branchName}
                    body={<>the AI Auto Receptionist (voice bot) runs on the central Dubai system. To answer a branch number with it, point that DID&rsquo;s destination to the central auto receptionist, or manage voice bots by switching to <b>Central</b>.</>} />
                : <BranchComingSoon page={activePage} siteName={branchName} />
      )}
    </AdminShell>
  );
}


function UserGroupsPage({ userGroups, users, onRefresh }: { userGroups: UserGroup[]; users: AdminUser[]; onRefresh: () => void }) {
  const [newName, setNewName] = React.useState('');
  const [newDesc, setNewDesc] = React.useState('');
  const [editing, setEditing] = React.useState<UserGroup | null>(null);
  const [editName, setEditName] = React.useState('');
  const [editDesc, setEditDesc] = React.useState('');
  const [expandedId, setExpandedId] = React.useState<number | null>(null);
  const [addingUser, setAddingUser] = React.useState<number | null>(null);
  const [selectedUserId, setSelectedUserId] = React.useState('');

  const createGroup = async () => {
    if (!newName.trim()) return;
    try {
      await api.post('/api/admin-panel/user-groups', { name: newName.trim(), description: newDesc.trim() });
      setNewName(''); setNewDesc('');
      onRefresh();
    } catch (e: any) { alert(e?.response?.data?.error || 'Failed'); }
  };

  const saveEdit = async (g: UserGroup) => {
    try {
      await api.put('/api/admin-panel/user-groups/' + g.id, { name: editName, description: editDesc });
      setEditing(null);
      onRefresh();
    } catch (e: any) { alert(e?.response?.data?.error || 'Failed'); }
  };

  const deleteGroup = async (g: UserGroup) => {
    if (!window.confirm('Delete group "' + g.name + '"?')) return;
    try {
      await api.delete('/api/admin-panel/user-groups/' + g.id);
      onRefresh();
    } catch (e: any) { alert(e?.response?.data?.error || 'Failed'); }
  };

  const addMember = async (groupId: number) => {
    if (!selectedUserId) return;
    try {
      await api.post('/api/admin-panel/user-groups/' + groupId + '/members', { user_id: Number(selectedUserId) });
      setSelectedUserId(''); setAddingUser(null);
      onRefresh();
    } catch (e: any) { alert(e?.response?.data?.error || 'Failed'); }
  };

  const removeMember = async (groupId: number, userId: number) => {
    try {
      await api.delete('/api/admin-panel/user-groups/' + groupId + '/members/' + userId);
      onRefresh();
    } catch (e: any) { alert(e?.response?.data?.error || 'Failed'); }
  };

  return (
    <>
      <div className="admin-page-title">User Groups</div>
      <div className="admin-page-subtitle">Group users for directory, permissions, and call pickup purposes.</div>

      <div className="content-card">
        <h3>Create Group</h3>
        <div className="admin-form-row">
          <input className="admin-input" value={newName} onChange={e => setNewName(e.target.value)} placeholder="Group name" />
          <input className="admin-input" value={newDesc} onChange={e => setNewDesc(e.target.value)} placeholder="Description (optional)" />
          <button className="primary-btn" onClick={createGroup}>Create Group</button>
        </div>
      </div>

      <div className="content-card">
        <h3>Groups <span style={{ fontSize:14, color:'#6b7280', fontWeight:400 }}>({userGroups.length})</span></h3>
        {userGroups.length === 0 && <p style={{ color:'#9ca3af', fontSize:14 }}>No user groups yet.</p>}
        {userGroups.map(g => (
          <div key={g.id} style={{ border:'1px solid #e5e7eb', borderRadius:12, marginBottom:12, overflow:'hidden' }}>
            <div style={{ padding:'14px 18px', display:'flex', alignItems:'center', gap:12, background:'#f9fafb' }}>
              {editing?.id === g.id ? (
                <>
                  <input className="admin-input" value={editName} onChange={e => setEditName(e.target.value)} style={{ flex:1 }} />
                  <input className="admin-input" value={editDesc} onChange={e => setEditDesc(e.target.value)} style={{ flex:2 }} placeholder="Description" />
                  <button className="primary-btn" onClick={() => saveEdit(g)}>Save</button>
                  <button className="secondary-btn" onClick={() => setEditing(null)}>Cancel</button>
                </>
              ) : (
                <>
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:700, fontSize:15 }}>{g.name}</div>
                    {g.description && <div style={{ fontSize:12, color:'#6b7280' }}>{g.description}</div>}
                  </div>
                  <span style={{ fontSize:12, color:'#6b7280' }}>{(g.members || []).length} member{(g.members || []).length !== 1 ? 's' : ''}</span>
                  <button className="secondary-btn" onClick={() => { setEditing(g); setEditName(g.name); setEditDesc(g.description || ''); }}>Edit</button>
                  <button className="secondary-btn" onClick={() => setExpandedId(expandedId === g.id ? null : g.id)}>
                    {expandedId === g.id ? 'Hide' : 'Members'}
                  </button>
                  <button className="danger-btn" onClick={() => deleteGroup(g)}>Delete</button>
                </>
              )}
            </div>
            {expandedId === g.id && (
              <div style={{ padding:'12px 18px' }}>
                {(g.members || []).map(m => (
                  <div key={m.user_id} style={{ display:'flex', alignItems:'center', gap:10, padding:'6px 0', borderBottom:'1px solid #f3f4f6' }}>
                    <span style={{ flex:1, fontSize:14 }}>
                      {(m.first_name || m.last_name) ? `${m.first_name || ''} ${m.last_name || ''}`.trim() + ' (' + m.username + ')' : m.username}
                    </span>
                    <button className="danger-btn" style={{ padding:'3px 10px', fontSize:12 }} onClick={() => removeMember(g.id, m.user_id)}>Remove</button>
                  </div>
                ))}
                {addingUser === g.id ? (
                  <div style={{ display:'flex', gap:10, marginTop:10 }}>
                    <select className="admin-select" value={selectedUserId} onChange={e => setSelectedUserId(e.target.value)} style={{ flex:1 }}>
                      <option value="">Select user…</option>
                      {users.filter(u => !(g.members || []).some(m => m.user_id === u.id)).map(u => (
                        <option key={u.id} value={u.id}>
                          {(u.first_name || u.last_name) ? `${u.first_name || ''} ${u.last_name || ''}`.trim() + ' (' + u.username + ')' : u.username}
                        </option>
                      ))}
                    </select>
                    <button className="primary-btn" onClick={() => addMember(g.id)}>Add</button>
                    <button className="secondary-btn" onClick={() => setAddingUser(null)}>Cancel</button>
                  </div>
                ) : (
                  <button className="secondary-btn" style={{ marginTop:10 }} onClick={() => setAddingUser(g.id)}>+ Add Member</button>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
}

function DashboardPage({ users, queues, user }: any) {
  const totalUsers = users.length;
  const activeUsers = users.filter((u: AdminUser) => !!u.is_active).length;
  const ccAgents = users.filter((u: AdminUser) => !!u.cc_enabled).length;
  const supervisors = users.filter((u: AdminUser) => !!u.supervisor_enabled || u.role === 'supervisor').length;

  return (
    <>
      <div className="admin-page-title">Platform Dashboard</div>
      <div className="admin-page-subtitle">
        Welcome {user.display_name || user.username}. Monitor tenants, users, queues, and contact center activity.
      </div>

      <div className="dashboard-grid">
        <StatCard title="Total Users" value={totalUsers} />
        <StatCard title="Active Users" value={activeUsers} />
        <StatCard title="CC Agents" value={ccAgents} />
        <StatCard title="Supervisors" value={supervisors} />
        <StatCard title="Queues" value={queues.length} />
      </div>

      <div className="content-card">
        <h3>System Overview</h3>
        <p>
          Multi-tenant backend, queue management, supervisor APIs, and normalized call history are active.
        </p>
      </div>
    </>
  );
}
function TenantsPage({
  tenants,
  newTenantName,
  setNewTenantName,
  newTenantCompany,
  setNewTenantCompany,
  newTenantDomain,
  setNewTenantDomain,
  newTenantEmail,
  setNewTenantEmail,
  newTenantMaxUsers,
  setNewTenantMaxUsers,
  newTenantAdminUsername,
  setNewTenantAdminUsername,
  newTenantAdminPassword,
  setNewTenantAdminPassword,
  createTenant,
  updateTenant,
  trunks
}: any) {
  return (
    <>
      <div className="admin-page-title">Tenant Management</div>
      <div className="admin-page-subtitle">
        Create tenants, manage company details, domains, and user limits.
      </div>

      <div className="content-card">
        <h3>Create Tenant</h3>

        <div className="admin-form-row">
          <input
            className="admin-input"
            value={newTenantName}
            onChange={(e) => setNewTenantName(e.target.value)}
            placeholder="Tenant name e.g. acme"
          />

          <input
            className="admin-input"
            value={newTenantCompany}
            onChange={(e) => setNewTenantCompany(e.target.value)}
            placeholder="Company name"
          />

          <input
            className="admin-input"
            value={newTenantDomain}
            onChange={(e) => setNewTenantDomain(e.target.value)}
            placeholder="Domain e.g. acme.example.com"
          />

          <input
            className="admin-input"
            value={newTenantEmail}
            onChange={(e) => setNewTenantEmail(e.target.value)}
            placeholder="Contact email"
          />

          <input
            className="admin-input small"
            type="number"
            value={newTenantMaxUsers}
            onChange={(e) => setNewTenantMaxUsers(Number(e.target.value))}
            placeholder="Max users"
          />

          <input
            id="newTenantExtBase"
            className="admin-input small"
            type="number"
            defaultValue={1000}
            placeholder="Ext base (e.g. 1000, 2000)"
            title="Extensions for this tenant start from this number"
          />

          <input
            className="admin-input"
            value={newTenantAdminUsername}
            onChange={(e) => setNewTenantAdminUsername(e.target.value)}
            placeholder="Admin username *"
            title="Required: admin account username for this tenant"
          />

          <input
            className="admin-input"
            type="password"
            value={newTenantAdminPassword}
            onChange={(e) => setNewTenantAdminPassword(e.target.value)}
            placeholder="Admin password * (min 6 chars)"
            title="Required: admin account password for this tenant"
          />

          <button
            className="primary-btn"
            onClick={createTenant}
          >
            Create Tenant
          </button>
        </div>
      </div>

      <div className="content-card">
        <h3>Tenants</h3>

        <table className="admin-table">
          <thead>
            <tr>
              <th>Tenant</th>
              <th>Company</th>
              <th>Domain</th>
              <th>Email</th>
              <th>Max Users</th>
              <th>Ext Base</th>
              <th>Default Trunk</th>
              <th>Outbound Limit</th>
              <th>Renumber</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {tenants.map((t: Tenant) => (
              <tr key={t.id}>
                <td>
                  <strong>{t.tenant_name}</strong>
                  <div className="admin-muted">ID {t.id}</div>
                </td>

                <td>
                  <input
                    className="admin-input"
                    value={t.company_name || ''}
                    onChange={(e) => updateTenant(t, { company_name: e.target.value })}
                  />
                </td>

                <td>
                  <input
                    className="admin-input"
                    value={t.domain_name || ''}
                    onChange={(e) => updateTenant(t, { domain_name: e.target.value })}
                  />
                </td>

                <td>
                  <input
                    className="admin-input"
                    value={t.contact_email || ''}
                    onChange={(e) => updateTenant(t, { contact_email: e.target.value })}
                  />
                </td>

                <td>
                  <input
                    className="admin-input small"
                    type="number"
                    value={t.max_users || 50}
                    onChange={(e) => updateTenant(t, { max_users: Number(e.target.value) })}
                  />
                </td>

                <td>
                  <input
                    className="admin-input small"
                    type="number"
                    title="Extension base number — new extensions start from this value"
                    value={t.extension_base || 1000}
                    onChange={(e) => updateTenant(t, { extension_base: Number(e.target.value) })}
                  />
                </td>

                <td>
                  <select
                    className="admin-select"
                    value={(t as any).primary_trunk_id || ''}
                    onChange={(e) => updateTenant(t, { primary_trunk_id: e.target.value ? Number(e.target.value) : null } as any)}
                    title="Default outbound trunk for all extensions in this tenant"
                  >
                    <option value="">— global default —</option>
                    {trunks.map((tr: any) => (
                      <option key={tr.id} value={tr.id}>
                        {tr.display_name || tr.trunk_name}
                      </option>
                    ))}
                  </select>
                </td>

                <td>
                  <label style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    <input type="checkbox" checked={!!t.outbound_limit_enabled}
                      onChange={(e) => updateTenant(t, { outbound_limit_enabled: e.target.checked ? 1 : 0 })} />
                    <input className="admin-input small" type="number" min={0} style={{ width: 70 }}
                      title="Outbound minutes per calendar month (0 = unlimited)" placeholder="min/mo"
                      value={t.outbound_limit_minutes || 0}
                      disabled={!t.outbound_limit_enabled}
                      onChange={(e) => updateTenant(t, { outbound_limit_minutes: Number(e.target.value) })} />
                  </label>
                </td>

                <td>
                  <button
                    className="admin-btn sm"
                    title="Renumber all extensions for this tenant starting from its extension base"
                    onClick={async () => {
                      if (!window.confirm(`Renumber all extensions for "${t.tenant_name}" starting from ${t.extension_base || 1000}? This will update the system automatically.`)) return;
                      try {
                        const result = await api.renumberTenantExtensions(t.id);
                        alert(`Done. ${result.renumbered?.length || 0} extensions renumbered.\n` +
                          (result.renumbered || []).map((r: any) => `${r.display}: ${r.old} → ${r.new}`).join('\n'));
                      } catch (e: any) {
                        alert(e?.response?.data?.error || 'Renumber failed');
                      }
                    }}
                  >
                    Renumber
                  </button>
                </td>

                <td>
                  <TogglePill
                    enabled={!!t.is_active}
                    onClick={() => updateTenant(t, { is_active: t.is_active ? 0 : 1 })}
                    onLabel="Active"
                    offLabel="Disabled"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

// ── Tenant Branding Page ───────────────────────────────────────────────────────
// Asset specs shown to the admin and used by the resize tool.
const BRANDING_ASSET_SPECS: Record<string, {
  key: string; title: string; accept: string; formats: string;
  w: number; h: number; sizeLabel: string; fit: 'inside' | 'cover'; note: string;
}> = {
  logo: {
    key: 'logo', title: 'Company Logo', accept: 'image/png,image/svg+xml,image/webp',
    formats: 'PNG, SVG or WebP', w: 512, h: 160, sizeLabel: 'up to 512 × 160 px',
    fit: 'inside', note: 'Use a horizontal logo with a transparent background. It replaces the CallEssential logo on the login page and sidebar.',
  },
  favicon: {
    key: 'favicon', title: 'Favicon (browser tab icon)', accept: 'image/png,image/x-icon,image/vnd.microsoft.icon',
    formats: 'PNG or ICO', w: 64, h: 64, sizeLabel: '64 × 64 px (square)',
    fit: 'cover', note: 'The small icon shown in the browser tab and bookmarks. A square image works best.',
  },
  'login-background': {
    key: 'login-background', title: 'Login Background', accept: 'image/jpeg,image/png,image/webp',
    formats: 'JPG, PNG or WebP', w: 1920, h: 1080, sizeLabel: '1920 × 1080 px (16:9)',
    fit: 'cover', note: 'A full-screen photo shown behind the login card. Landscape 16:9 images look best.',
  },
};

function TenantBrandingPage({ tenants, user }: { tenants: Tenant[]; user: any }) {
  const isSuperAdmin = !!(user?.role === 'super_admin' || user?.is_admin);
  const visibleTenants = isSuperAdmin ? tenants : tenants.filter(t => t.id === user?.tenant_id);
  const [selectedId, setSelectedId] = React.useState<number | null>(
    visibleTenants.length === 1 ? visibleTenants[0].id : null
  );
  const [branding, setBranding] = React.useState<any>({});
  const [saving, setSaving] = React.useState(false);
  const [uploading, setUploading] = React.useState<string | null>(null);
  const [resizing, setResizing] = React.useState<string | null>(null);
  const [status, setStatus] = React.useState('');
  const [statusOk, setStatusOk] = React.useState(false);
  // Per-asset last-known dimensions + a cache-buster so previews refresh in place.
  const [dims, setDims] = React.useState<Record<string, { width: number; height: number } | null>>({});
  const [bust, setBust] = React.useState<number>(Date.now());
  const [processingAvailable, setProcessingAvailable] = React.useState(true);
  // Manual resize tool inputs, keyed per asset.
  const [manual, setManual] = React.useState<Record<string, { w: string; h: string; fit: string }>>({});

  // Uploads are served from the same origin as the API.
  const BACKEND_BASE = '';

  React.useEffect(() => {
    if (!selectedId) return;
    setStatus('');
    api.getTenantBranding(selectedId)
      .then((d: any) => { setBranding(d.branding || {}); setDims({}); setBust(Date.now()); })
      .catch(() => setBranding({}));
  }, [selectedId]);

  const flash = (msg: string, ok: boolean) => { setStatus(msg); setStatusOk(ok); };

  const save = async () => {
    if (!selectedId) return;
    setSaving(true); setStatus('');
    try {
      await api.updateTenantBranding(selectedId, {
        company_name:    branding.company_name    || null,
        primary_color:   branding.primary_color   || null,
        secondary_color: branding.secondary_color || null,
        subdomain:       branding.subdomain        || null,
        custom_domain:   branding.custom_domain    || null,
        hide_powered_by: !!branding.hide_powered_by,
      });
      flash('Branding saved successfully.', true);
    } catch (e: any) {
      flash(e?.response?.data?.error || 'Save failed.', false);
    } finally {
      setSaving(false);
    }
  };

  const urlMap: Record<string, string> = {
    logo: 'logo_url', favicon: 'favicon_url', 'login-background': 'login_bg_url',
  };

  const uploadAsset = async (asset: string, file: File) => {
    if (!selectedId) return;
    const spec = BRANDING_ASSET_SPECS[asset];
    if (file.size > 5 * 1024 * 1024) { flash('File is larger than 5 MB.', false); return; }
    setUploading(asset); setStatus('');
    try {
      const result = await api.uploadTenantAsset(selectedId, asset, file);
      setBranding((prev: any) => ({ ...prev, [urlMap[asset]]: result.url }));
      if (result.dimensions) setDims(prev => ({ ...prev, [asset]: { width: result.dimensions.width, height: result.dimensions.height } }));
      if (typeof result.processing === 'boolean') setProcessingAvailable(result.processing);
      setBust(Date.now());
      flash(`${spec.title} uploaded.`, true);
    } catch (e: any) {
      flash(e?.response?.data?.error || 'Upload failed.', false);
    } finally {
      setUploading(null);
    }
  };

  const resizeAsset = async (asset: string, width: number, height: number, fit: string) => {
    if (!selectedId) return;
    setResizing(asset); setStatus('');
    try {
      const result = await api.resizeTenantAsset(selectedId, asset, { width, height, fit });
      if (result.dimensions) setDims(prev => ({ ...prev, [asset]: { width: result.dimensions.width, height: result.dimensions.height } }));
      setBust(Date.now());
      flash(`${BRANDING_ASSET_SPECS[asset].title} resized to ${result.dimensions.width} × ${result.dimensions.height} px.`, true);
    } catch (e: any) {
      flash(e?.response?.data?.error || 'Resize failed.', false);
    } finally {
      setResizing(null);
    }
  };

  const setField = (key: string, val: any) =>
    setBranding((prev: any) => ({ ...prev, [key]: val }));

  // Does the uploaded asset differ from its recommended size?
  const isMismatch = (asset: string): boolean => {
    const d = dims[asset]; const spec = BRANDING_ASSET_SPECS[asset];
    if (!d || !spec) return false;
    if (asset === 'favicon') return d.width !== spec.w || d.height !== spec.h;
    // logo / background: flag if it exceeds the recommended envelope
    return d.width > spec.w || d.height > spec.h;
  };

  const assetPreview = (asset: string) => {
    const url = branding[urlMap[asset]];
    if (!url) return null;
    return `${BACKEND_BASE}${url}?v=${bust}`;
  };

  const previewName = branding.company_name || 'Your Company';
  const hasLogoPreview = !!branding.logo_url;

  return (
    <>
      <div className="admin-page-title">Tenant Branding</div>
      <div className="admin-page-subtitle">
        White-label the portal for each tenant — logo, colours, login page and domain.
        Image uploads are optimised automatically; use the resize tool if a picture does not fit.
      </div>

      {isSuperAdmin && (
        <div className="content-card">
          <h3>Select Tenant</h3>
          <div className="admin-form-row">
            <select
              className="admin-input"
              value={selectedId || ''}
              onChange={e => setSelectedId(Number(e.target.value) || null)}
            >
              <option value="">— select tenant —</option>
              {tenants.map(t => (
                <option key={t.id} value={t.id}>{t.tenant_name} (ID {t.id})</option>
              ))}
            </select>
          </div>
        </div>
      )}

      {selectedId && (
        <>
          {/* Identity */}
          <div className="content-card">
            <h3>Brand Identity</h3>
            <div className="admin-form-row">
              <div style={{ flex: 1, minWidth: 240 }}>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px', color: '#9ca3af' }}>Display Name</label>
                <input
                  className="admin-input"
                  value={branding.company_name || ''}
                  onChange={e => setField('company_name', e.target.value)}
                  placeholder="The Executive Centre"
                  style={{ width: '100%' }}
                />
                <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '4px' }}>
                  Shown on the login page and sidebar when no logo is uploaded.
                </div>
              </div>
              <div style={{ minWidth: 240 }}>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px', color: '#9ca3af' }}>White-label</label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, color: '#e2e8f0', marginTop: 6 }}>
                  <input
                    type="checkbox"
                    checked={!!branding.hide_powered_by}
                    onChange={e => setField('hide_powered_by', e.target.checked)}
                    style={{ width: 16, height: 16 }}
                  />
                  Hide “powered by Synergytalk” attribution
                </label>
              </div>
            </div>
          </div>

          {/* Images */}
          <div className="content-card">
            <h3>Logo &amp; Images</h3>
            {!processingAvailable && (
              <div style={{ fontSize: '12px', color: '#f59e0b', marginBottom: 10 }}>
                Automatic image optimisation is offline — uploads are stored as-is and the resize tool is unavailable.
              </div>
            )}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '18px' }}>
              {Object.values(BRANDING_ASSET_SPECS).map(spec => {
                const asset = spec.key;
                const preview = assetPreview(asset);
                const d = dims[asset];
                const mism = isMismatch(asset);
                const m = manual[asset] || { w: String(spec.w), h: String(spec.h), fit: spec.fit };
                return (
                  <div key={asset} style={{ border: '1px solid rgba(255,255,255,0.08)', borderRadius: 10, padding: 14, background: 'rgba(255,255,255,0.02)' }}>
                    <div style={{ fontWeight: 700, fontSize: 14, color: '#f1f5f9' }}>{spec.title}</div>
                    <div style={{ fontSize: 12, color: '#94a3b8', margin: '4px 0 2px' }}>
                      Recommended: <strong style={{ color: '#cbd5e1' }}>{spec.sizeLabel}</strong> · {spec.formats} · max 5 MB
                    </div>
                    <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 10 }}>{spec.note}</div>

                    {/* Preview */}
                    <div style={{
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      minHeight: 72, borderRadius: 8, marginBottom: 8,
                      background: asset === 'logo'
                        ? 'repeating-conic-gradient(#2a2a3e 0% 25%, #1a1a2e 0% 50%) 50% / 16px 16px'
                        : '#12121f',
                      padding: 6,
                    }}>
                      {preview ? (
                        <img
                          src={preview}
                          alt={spec.title}
                          style={asset === 'favicon'
                            ? { width: 40, height: 40, objectFit: 'contain' }
                            : asset === 'login-background'
                            ? { maxWidth: '100%', maxHeight: 90, objectFit: 'cover', borderRadius: 6 }
                            : { maxWidth: '100%', maxHeight: 60, objectFit: 'contain' }}
                        />
                      ) : (
                        <span style={{ fontSize: 12, color: '#4b5563' }}>No image uploaded</span>
                      )}
                    </div>

                    {/* Dimensions + mismatch */}
                    {d && (
                      <div style={{ fontSize: 11, marginBottom: 8, color: mism ? '#f59e0b' : '#34d399' }}>
                        Current: {d.width} × {d.height} px {mism ? '· differs from recommended' : '· looks good'}
                      </div>
                    )}

                    {/* File input */}
                    <input
                      type="file"
                      accept={spec.accept}
                      disabled={!!uploading || !!resizing}
                      onChange={e => { const f = e.target.files?.[0]; if (f) uploadAsset(asset, f); e.currentTarget.value = ''; }}
                      style={{ fontSize: 12, color: '#cbd5e1', width: '100%' }}
                    />
                    {uploading === asset && <span style={{ fontSize: '12px', color: '#a855f7' }}> Uploading…</span>}

                    {/* Resize tool — shown once an image exists */}
                    {preview && processingAvailable && (
                      <div style={{ marginTop: 10, borderTop: '1px dashed rgba(255,255,255,0.08)', paddingTop: 10 }}>
                        {mism && (
                          <button
                            className="admin-input"
                            disabled={!!resizing}
                            onClick={() => resizeAsset(asset, spec.w, spec.h, spec.fit)}
                            style={{ cursor: 'pointer', background: '#7c3aed', color: '#fff', border: 'none', borderRadius: 6, padding: '6px 10px', fontSize: 12, fontWeight: 600, width: '100%', marginBottom: 8 }}
                          >
                            {resizing === asset ? 'Resizing…' : `Auto-fit to ${spec.sizeLabel}`}
                          </button>
                        )}
                        <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4 }}>Custom resize:</div>
                        <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                          <input value={m.w} onChange={e => setManual(p => ({ ...p, [asset]: { ...m, w: e.target.value } }))}
                            placeholder="W" style={{ width: 52, fontSize: 12, padding: '4px 6px', background: '#12121f', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 5, color: '#e2e8f0' }} />
                          <span style={{ color: '#64748b' }}>×</span>
                          <input value={m.h} onChange={e => setManual(p => ({ ...p, [asset]: { ...m, h: e.target.value } }))}
                            placeholder="H" style={{ width: 52, fontSize: 12, padding: '4px 6px', background: '#12121f', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 5, color: '#e2e8f0' }} />
                          <select value={m.fit} onChange={e => setManual(p => ({ ...p, [asset]: { ...m, fit: e.target.value } }))}
                            style={{ fontSize: 11, padding: '4px', background: '#12121f', border: '1px solid rgba(255,255,255,0.12)', borderRadius: 5, color: '#e2e8f0' }}>
                            <option value="inside">fit</option>
                            <option value="cover">crop</option>
                            <option value="fill">stretch</option>
                          </select>
                          <button
                            disabled={!!resizing}
                            onClick={() => resizeAsset(asset, parseInt(m.w, 10) || spec.w, parseInt(m.h, 10) || spec.h, m.fit)}
                            style={{ cursor: 'pointer', background: 'rgba(255,255,255,0.08)', color: '#e2e8f0', border: '1px solid rgba(255,255,255,0.14)', borderRadius: 5, padding: '4px 10px', fontSize: 12 }}
                          >Apply</button>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          {/* Colours */}
          <div className="content-card">
            <h3>Colours</h3>
            <div className="admin-form-row">
              <div>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px', color: '#9ca3af' }}>Primary Colour</label>
                <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 6 }}>Buttons, links and accents.</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <input type="color" value={branding.primary_color || '#a855f7'} onChange={e => setField('primary_color', e.target.value)}
                    style={{ width: '44px', height: '36px', padding: '2px', border: 'none', cursor: 'pointer', borderRadius: '6px' }} />
                  <input className="admin-input" value={branding.primary_color || ''} onChange={e => setField('primary_color', e.target.value)}
                    placeholder="#C8A84B" style={{ width: '120px' }} />
                </div>
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px', color: '#9ca3af' }}>Secondary Colour</label>
                <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 6 }}>Login page background (if no image).</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <input type="color" value={branding.secondary_color || '#1a1a2e'} onChange={e => setField('secondary_color', e.target.value)}
                    style={{ width: '44px', height: '36px', padding: '2px', border: 'none', cursor: 'pointer', borderRadius: '6px' }} />
                  <input className="admin-input" value={branding.secondary_color || ''} onChange={e => setField('secondary_color', e.target.value)}
                    placeholder="#1A1A2E" style={{ width: '120px' }} />
                </div>
              </div>
            </div>
          </div>

          {/* Live preview */}
          <div className="content-card">
            <h3>Login Preview</h3>
            <div style={{
              borderRadius: 12, padding: 24, display: 'flex', justifyContent: 'center',
              background: branding.login_bg_url
                ? `center / cover no-repeat url(${assetPreview('login-background')})`
                : (branding.secondary_color || '#1a1a2e'),
            }}>
              <div style={{ background: 'rgba(255,255,255,0.92)', borderRadius: 14, padding: '26px 30px', width: 260, textAlign: 'center', boxShadow: '0 20px 50px rgba(0,0,0,0.35)' }}>
                {hasLogoPreview ? (
                  <img src={assetPreview('logo') || ''} alt="logo" style={{ maxWidth: 180, maxHeight: 70, objectFit: 'contain' }} />
                ) : (
                  <div style={{ fontWeight: 800, fontSize: 20, color: '#0d1b38' }}>{previewName}</div>
                )}
                <div style={{ fontSize: 13, color: '#475569', margin: '14px 0 10px' }}>Sign in to your account</div>
                <div style={{ height: 34, borderRadius: 7, background: '#eef2f7', marginBottom: 8 }} />
                <div style={{ height: 34, borderRadius: 7, background: '#eef2f7', marginBottom: 12 }} />
                <div style={{ height: 36, borderRadius: 8, background: branding.primary_color || '#a855f7', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 600, fontSize: 13 }}>Sign In</div>
                <div style={{ fontSize: 10, color: '#94a3b8', marginTop: 14 }}>
                  {branding.hide_powered_by ? 'Secure TLS · WebRTC' : 'Secure TLS · WebRTC · Powered by SynergyTalk'}
                </div>
              </div>
            </div>
          </div>

          {/* Domains */}
          <div className="content-card">
            <h3>Domain Settings</h3>
            <div className="admin-form-row">
              <div>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px', color: '#9ca3af' }}>Subdomain</label>
                <input className="admin-input" value={branding.subdomain || ''} onChange={e => setField('subdomain', e.target.value)} placeholder="executivecentre" />
                <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '4px' }}>e.g. executivecentre → executivecentre.dev.callessential.cc</div>
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: '4px', fontSize: '13px', color: '#9ca3af' }}>Custom Domain</label>
                <input className="admin-input" value={branding.custom_domain || ''} onChange={e => setField('custom_domain', e.target.value)} placeholder="portal.executivecentre.com" />
                <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '4px' }}>Point your DNS CNAME to dev.callessential.cc</div>
              </div>
            </div>
          </div>

          {status && (
            <div style={{ padding: '10px 16px', borderRadius: '8px', background: statusOk ? '#d1fae5' : '#fee2e2', color: statusOk ? '#065f46' : '#991b1b', marginBottom: '12px', fontSize: '13px' }}>
              {status}
            </div>
          )}

          <div style={{ display: 'flex', gap: '12px' }}>
            <button className="primary-btn" onClick={save} disabled={saving}>
              {saving ? 'Saving…' : 'Save Branding'}
            </button>
          </div>
        </>
      )}
    </>
  );
}

const ROLE_LABELS: Record<string, string> = {
  pbx_user: 'PBX User',
  agent: 'CC Agent',
  supervisor: 'Supervisor',
  tenant_admin: 'Tenant Admin',
  pbx_admin: 'PBX Administrator',
};
// Access-group members carry pbx_admin internally; show their telephone role + group (2026-10-28)
// Role = telephone role only (2026-10-28); the group is shown in its own "Access group" column
const telRole = (u: any) => (u?.access_profile_id && u.role === 'pbx_admin' ? (u.profile_prev_role || 'pbx_user') : (u?.role || 'pbx_user'));
const roleText = (u: any) => ROLE_LABELS[telRole(u)] || telRole(u);
// Self-service call handling permission (2026-10-28, TEC): forwarding is chargeable, so users only manage
// their own call handling when a sub-admin / tenant admin ticks this. Hidden where not enforced and for view-only groups.
function SelfChToggle({ userId }: { userId: number }) {
  const [st, setSt] = React.useState<any>(null);
  React.useEffect(() => { axios.get(`/api/call-handling/${userId}/self-service`).then((r) => setSt(r.data)).catch(() => setSt(null)); }, [userId]);
  if (!st || !st.enforced || isViewOnlySession()) return null;
  const flip = async (on: boolean) => {
    try { await axios.put(`/api/call-handling/${userId}/self-service`, { enabled: on }); setSt({ ...st, enabled: on }); }
    catch (e: any) { alert(e?.response?.data?.error || 'Could not change this setting'); }
  };
  return (
    <label style={{ display: 'flex', gap: 6, alignItems: 'flex-start', fontSize: '12px', color: '#374151', marginTop: '8px' }}>
      <input type="checkbox" style={{ width: 'auto', marginTop: 2 }} checked={!!st.enabled} onChange={(e) => flip(e.target.checked)} />
      <span>User can manage their own call handling in the app (forwarding, working hours, ring time) — <i>forwarding is chargeable</i>. Saved straight away.</span>
    </label>
  );
}
function canGrantTenantAdmin(): boolean {
  try { const u = JSON.parse(localStorage.getItem('ce_session') || '{}')?.user || {}; return u.role === 'tenant_admin' || u.role === 'super_admin'; } catch (_) { return false; }
}

const ROLE_COLORS: Record<string, { bg: string; color: string }> = {
  pbx_user:    { bg: '#f3f4f6', color: '#374151' },
  agent:       { bg: '#dbeafe', color: '#1d4ed8' },
  supervisor:  { bg: '#ede9fe', color: '#6d28d9' },
  tenant_admin:{ bg: '#fef3c7', color: '#92400e' },
  pbx_admin:   { bg: '#dcfce7', color: '#166534' },
};

// 2026-10-23: members of an access group (e.g. Operations) manage PBX users only
function isViewOnlySession(): boolean {
  try { const ap = JSON.parse(localStorage.getItem('ce_session') || '{}')?.user?.access_profile; return !!ap && ap.restrictions?.read_only === true; } catch (_) { return false; }
}

// 2026-10-30: view-only group that may still upload/edit greetings (write_allow covers the recordings library)
function viewOnlyGreetings(): boolean {
  try { const ap = JSON.parse(localStorage.getItem('ce_session') || '{}')?.user?.access_profile; return (ap?.restrictions?.write_allow || []).some((e: string) => String(e).includes('recordings-library')); } catch (_) { return false; }
}

function isOpsSession(): boolean {
  // groups without restrictions (e.g. Sub-Admins) keep the full sub-admin screens
  try { const ap = JSON.parse(localStorage.getItem('ce_session') || '{}')?.user?.access_profile; return !!ap && Array.isArray(ap.restrictions?.user_roles); } catch (_) { return false; }
}

function EditUserModal({ user, onSave, onClose, onDelete }: {
  user: AdminUser;
  onSave: (u: AdminUser, changes: Partial<AdminUser>, newPw: string) => void;
  onClose: () => void;
  onDelete: (u: AdminUser) => void;
}) {
  const [draft, setDraft]       = React.useState<AdminUser>({ ...user });
  const [newPw, setNewPw]       = React.useState('');
  const [saving, setSaving]     = React.useState(false);
  const [saveError, setSaveError] = React.useState('');
  const [licData, setLicData]   = React.useState<any>(null);

  // Load license data for this user's tenant
  React.useEffect(() => {
    if (user.tenant_id) {
      api.getTenantLicenseWithUsage(user.tenant_id).then(setLicData).catch(() => setLicData(null));
    }
  }, [user.tenant_id]);

  const set = (field: keyof AdminUser, value: any) =>
    setDraft(prev => ({ ...prev, [field]: value }));

  const handleRoleChange = (role: string) => {
    const extra: Partial<AdminUser> = { role };
    if (role === 'agent')       { extra.cc_enabled = 1; extra.queue_enabled = 1; extra.supervisor_enabled = 0; }
    if (role === 'supervisor')  { extra.cc_enabled = 1; extra.queue_enabled = 1; extra.supervisor_enabled = 1; }
    if (role === 'pbx_user')    { extra.cc_enabled = 0; extra.queue_enabled = 0; extra.supervisor_enabled = 0; }
    setDraft(prev => ({ ...prev, ...extra }));
  };

  const handleSave = async () => {
    setSaving(true); setSaveError('');
    try {
      await onSave(user, draft, newPw);
    } catch (e: any) {
      const msg = e?.response?.data?.message || e?.response?.data?.error || 'Failed to save';
      setSaveError(msg);
    }
    setSaving(false);
  };

  // License availability helper
  const licAvail = (key: string, usedKey: string): { avail: boolean; used: number; total: number } => {
    if (!licData) return { avail: true, used: 0, total: 0 };
    const total = Number(licData[key] || 0);
    const used  = Number(licData[usedKey] || 0);
    if (total === 0) return { avail: true, used, total }; // 0 = unset, don't block
    return { avail: used < total, used, total };
  };

  // Licensed toggle: shows usage badge, warns if limit reached
  const LicToggle = ({ label, field, licKey, usedKey }: { label: string; field: keyof AdminUser; licKey: string; usedKey: string }) => {
    const { avail, used, total } = licAvail(licKey, usedKey);
    const isOn = !!draft[field];
    const wouldExceed = !isOn && !avail; // trying to turn ON when at limit
    return (
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'8px 0', borderBottom:'1px solid #f3f4f6' }}>
        <div>
          <span style={{ fontSize:'14px', color:'#374151' }}>{label}</span>
          {total > 0 && (
            <span style={{
              marginLeft:'8px', fontSize:'10px', padding:'1px 7px', borderRadius:'99px', fontWeight:700,
              background: used >= total ? '#fee2e2' : '#f0fdf4',
              color: used >= total ? '#991b1b' : '#166534',
            }}>
              {used}/{total}
            </span>
          )}
        </div>
        <div style={{ display:'flex', flexDirection:'column', alignItems:'flex-end', gap:'2px' }}>
          {wouldExceed && (
            <div style={{ fontSize:'10px', color:'#dc2626', fontWeight:600 }}>⚠ License limit reached</div>
          )}
          <TogglePill
            enabled={isOn}
            onClick={() => {
              if (wouldExceed) return; // block the toggle
              set(field, isOn ? 0 : 1);
            }}
            onLabel="On"
            offLabel="Off"
          />
        </div>
      </div>
    );
  };

  const FeatureRow = ({ label, field }: { label: string; field: keyof AdminUser }) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #f3f4f6' }}>
      <span style={{ fontSize: '14px', color: '#374151' }}>{label}</span>
      <TogglePill
        enabled={!!draft[field]}
        onClick={() => set(field, draft[field] ? 0 : 1)}
        onLabel="On"
        offLabel="Off"
      />
    </div>
  );

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1000,
      background: 'rgba(0,0,0,0.45)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '16px',
    }}>
      <div style={{
        background: '#fff', borderRadius: '20px', width: '100%', maxWidth: '540px',
        maxHeight: '90vh', overflowY: 'auto',
        boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
      }}>
        {/* Header */}
        <div style={{ padding: '24px 28px 20px', borderBottom: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div>
            <div style={{ fontWeight: 800, fontSize: '18px' }}>{user.username}</div>
            <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '2px' }}>
              Tenant {user.tenant_id || 1} · ID #{user.id}
              {user.extension_number && (
                <span style={{ marginLeft: '8px', color: '#6366f1', fontWeight: 700 }}>· Ext {user.extension_number}</span>
              )}
            </div>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: '22px', cursor: 'pointer', color: '#9ca3af', lineHeight: 1 }}>✕</button>
        </div>

        <div style={{ padding: '20px 28px' }}>

          {/* Profile */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontSize: '11px', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '10px' }}>Profile</div>

            {/* Avatar */}
            <div style={{ display:'flex', alignItems:'center', gap:'14px', marginBottom:'14px' }}>
              <div style={{ position:'relative', cursor:'pointer' }} onClick={() => (document.getElementById('avatar-upload-' + user.id) as HTMLInputElement)?.click()}>
                {draft.avatar_url
                  ? <img src={draft.avatar_url} alt="avatar" style={{ width:56, height:56, borderRadius:'50%', objectFit:'cover', border:'2px solid #e5e7eb' }} />
                  : <div style={{ width:56, height:56, borderRadius:'50%', background:'#6366f1', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontWeight:800, fontSize:20 }}>
                      {(draft.first_name || draft.username || '?')[0].toUpperCase()}
                    </div>
                }
                <div style={{ position:'absolute', bottom:0, right:0, width:20, height:20, borderRadius:'50%', background:'#fff', border:'1px solid #d1d5db', display:'flex', alignItems:'center', justifyContent:'center', fontSize:11 }}>✏️</div>
              </div>
              <input id={'avatar-upload-' + user.id} type="file" accept="image/*" style={{ display:'none' }} onChange={(e) => {
                const file = e.target.files?.[0]; if (!file) return;
                const reader = new FileReader();
                reader.onload = (ev) => set('avatar_url', ev.target?.result as string);
                reader.readAsDataURL(file);
              }} />
              <div>
                <div style={{ fontSize:13, fontWeight:600, color:'#374151' }}>Profile Photo</div>
                <div style={{ fontSize:11, color:'#9ca3af' }}>Click to upload (JPG/PNG, max 450 KB)</div>
              </div>
            </div>

            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px', marginBottom:'10px' }}>
              <div>
                <label style={{ fontSize:'12px', color:'#6b7280', display:'block', marginBottom:'4px' }}>First Name</label>
                <input className="admin-input" style={{ width:'100%' }} value={draft.first_name || ''} onChange={(e) => set('first_name', e.target.value)} placeholder="First name" />
              </div>
              <div>
                <label style={{ fontSize:'12px', color:'#6b7280', display:'block', marginBottom:'4px' }}>Last Name</label>
                <input className="admin-input" style={{ width:'100%' }} value={draft.last_name || ''} onChange={(e) => set('last_name', e.target.value)} placeholder="Last name" />
              </div>
            </div>

            <div style={{ marginBottom:'10px' }}>
              <label style={{ fontSize:'12px', color:'#6b7280', display:'block', marginBottom:'4px' }}>Email</label>
              <input className="admin-input" style={{ width:'100%' }} type="email" value={draft.email || ''} onChange={(e) => set('email', e.target.value)} placeholder="user@company.com" />
            </div>

            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px', marginBottom:'10px' }}>
              <div>
                <label style={{ fontSize:'12px', color:'#6b7280', display:'block', marginBottom:'4px' }}>Department</label>
                <input className="admin-input" style={{ width:'100%' }} value={draft.department || ''} onChange={(e) => set('department', e.target.value)} placeholder="Department" />
              </div>
              <div>
                <label style={{ fontSize:'12px', color:'#6b7280', display:'block', marginBottom:'4px' }}>Job Title</label>
                <input className="admin-input" style={{ width:'100%' }} value={draft.job_title || ''} onChange={(e) => set('job_title', e.target.value)} placeholder="Job title" />
              </div>
            </div>

            <div style={{ marginBottom:'10px' }}>
              <label style={{ fontSize:'12px', color:'#6b7280', display:'block', marginBottom:'4px' }}>Location</label>
              <LocationSelect className="admin-input" style={{ width:'100%' }} value={draft.location || ''} onChange={(v: any) => set('location', v)} />
            </div>
          </div>

          {/* Role & Account */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontSize: '11px', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '10px' }}>Role & Account</div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              <div>
                <label style={{ fontSize: '12px', color: '#6b7280', display: 'block', marginBottom: '4px' }}>Role</label>
                <select
                  className="admin-select"
                  style={{ width: '100%' }}
                  value={(draft as any).access_profile_id && draft.role === 'pbx_admin' ? ((draft as any).profile_prev_role || 'pbx_user') : (draft.role || 'pbx_user')}
                  disabled={isOpsSession()}
                  title={isOpsSession() ? 'The Operations team manages PBX users only' : undefined}
                  onChange={(e) => handleRoleChange(e.target.value)}
                >
                  <option value="pbx_user">PBX User</option>
                  <option value="agent">CC Agent</option>
                  <option value="supervisor">Supervisor</option>
                  {(draft.role === 'tenant_admin' || canGrantTenantAdmin()) && !(draft as any).access_profile_id && <option value="tenant_admin">Tenant Admin</option>}
                  {draft.role === 'pbx_admin' && !(draft as any).access_profile_id && <option value="pbx_admin">PBX Administrator</option>}
                </select>
                {(draft as any).access_profile_id ? <div style={{ fontSize: '11px', color: '#6b7280', marginTop: '4px' }}>Admin access: {(draft as any).access_group || 'access group'} — managed in User Management › Access groups</div> : null}
                <SelfChToggle userId={Number((user as any).id)} />
              </div>
              <div>
                <label style={{ fontSize: '12px', color: '#6b7280', display: 'block', marginBottom: '4px' }}>Account Status</label>
                <TogglePill
                  enabled={!!draft.is_active}
                  onClick={() => set('is_active', draft.is_active ? 0 : 1)}
                  onLabel="Active"
                  offLabel="Disabled"
                />
              </div>
            </div>
          </div>

          {/* Contact Center — licensed */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontSize: '11px', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '10px' }}>Contact Center</div>
            <LicToggle label="CC Enabled"   field="cc_enabled"         licKey="contact_centre" usedKey="used_contact_centre" />
            {!isOpsSession() && <LicToggle label="Supervisor"   field="supervisor_enabled" licKey="supervisor"      usedKey="used_supervisor" />}
            <FeatureRow label="Queue"       field="queue_enabled" />
          </div>

          {/* AI — licensed */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontSize: '11px', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '10px' }}>AI &amp; Voice Bot</div>
            {!isOpsSession() && <LicToggle label="AI Agent"    field="ai_agent_enabled"  licKey="ai_agent"  usedKey="used_ai_agent" />}
            {!isOpsSession() && <LicToggle label="Voice Bot"   field="voice_bot_enabled" licKey="voice_bot"  usedKey="used_voice_bot" />}
            <FeatureRow label="AI Transcription" field="feature_ai_transcription" />
          </div>

          {/* App access (2026-11-02) */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontSize: '11px', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '10px' }}>App Access</div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #f3f4f6' }}>
              <span style={{ fontSize: '14px', color: '#374151' }}>Mobile app (iOS / Android)</span>
              <TogglePill enabled={Number(draft.mobile_app_allowed ?? 1) === 1} onClick={() => set('mobile_app_allowed', Number(draft.mobile_app_allowed ?? 1) === 1 ? 0 : 1)} onLabel="Allowed" offLabel="Blocked" />
            </div>
            <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '6px' }}>Blocked = the user can only sign in on the web portal and the desktop app; signed-in phones are signed out. Desk phones are not affected.</div>
          </div>

          {/* Features */}
          <div style={{ marginBottom: '20px' }}>
            <div style={{ fontSize: '11px', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '10px' }}>Features</div>
            <FeatureRow label="Recording"         field="feature_recording" />
            <FeatureRow label="Contacts"          field="feature_contacts" />
            <FeatureRow label="From Number (CLI)" field="feature_from_number" />
            <FeatureRow label="Recent Calls"      field="feature_recent_calls" />
            <FeatureRow label="Settings"          field="feature_settings" />
            <FeatureRow label="Transfer"          field="feature_transfer" />
            <FeatureRow label="Queue Mode"        field="feature_queue_mode" />
            {!isOpsSession() && <FeatureRow label="Supervisor View"   field="feature_supervisor" />}
            {!isOpsSession() && <FeatureRow label="Wallboard"         field="feature_wallboard" />}
            <FeatureRow label="CRM Popup"         field="feature_crm_popup" />
          </div>

          {/* Password Reset */}
          <div style={{ marginBottom: '24px' }}>
            <div style={{ fontSize: '11px', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: '10px' }}>Reset Password</div>
            <div style={{ display: 'flex', gap: '10px' }}>
              <input
                className="admin-input"
                type="password"
                style={{ flex: 1 }}
                value={newPw}
                onChange={(e) => setNewPw(e.target.value)}
                placeholder="Leave blank to keep current password"
              />
            </div>
          </div>

          {/* Footer */}
          {saveError && (
            <div style={{ marginBottom:'12px', padding:'10px 14px', borderRadius:'8px', background:'#fef2f2', border:'1px solid #fecaca', color:'#dc2626', fontSize:'13px' }}>
              ⚠ {saveError}
            </div>
          )}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '16px', borderTop: '1px solid #f0f0f0' }}>
            <button
              className="danger-btn"
              onClick={() => { onClose(); onDelete(user); }}
            >
              Delete User
            </button>
            <div style={{ display: 'flex', gap: '10px' }}>
              <button className="secondary-btn" onClick={onClose}>Cancel</button>
              <button
                className="primary-btn"
                onClick={handleSave}
                disabled={saving}
              >
                {saving ? 'Saving…' : 'Save Changes'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function UsersPage({
  users,
  search,
  setSearch,
  newUsername,
  setNewUsername,
  newPassword,
  setNewPassword,
  newFirstName,
  setNewFirstName,
  newLastName,
  setNewLastName,
  newEmail,
  setNewEmail,
  newDepartment,
  setNewDepartment,
  newJobTitle,
  setNewJobTitle,
  newLocation,
  setNewLocation,
  newExtension,
  setNewExtension,
  createUser,
  updateUser,
  resetPassword,
  deleteUser,
  tenants,
  showTenantSelector
}: any) {
  const [editingUser, setEditingUser] = React.useState<AdminUser | null>(null);
  const tenantName = (id: any) => { const t=(tenants||[]).find((x: any)=>x.id===Number(id)); return (t && (t.tenant_name||t.name||t.company_name)) || (id?('Tenant '+id):'\u2014'); };

  const handleSave = async (u: AdminUser, changes: Partial<AdminUser>, newPw: string) => {
    await updateUser(u, changes);
    if (newPw.trim()) {
      await resetPassword(u, newPw.trim());
    }
    setEditingUser(null);
  };

  return (
    <>
      {editingUser && (
        <EditUserModal
          user={editingUser}
          onSave={handleSave}
          onClose={() => setEditingUser(null)}
          onDelete={deleteUser}
        />
      )}

      <div className="admin-page-title">User Management</div>
      <div className="admin-page-subtitle">
        Create PBX users, CC agents, supervisors, and tenant administrators.
      </div>

      <div className="content-card">
        <h3>Create User</h3>

        <div className="admin-form-row">
          <input
            className="admin-input"
            value={newUsername}
            onChange={(e) => setNewUsername(e.target.value)}
            placeholder="Extension / Username"
          />

          <input
            className="admin-input"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            placeholder="Password"
          />

          <input
            className="admin-input"
            value={newExtension}
            onChange={(e) => setNewExtension(e.target.value)}
            placeholder="Extension (optional — auto if blank)"
          />

          <button className="primary-btn" onClick={createUser}>
            Create User
          </button>
        </div>

        <div className="admin-form-row">
          <input
            className="admin-input"
            value={newFirstName}
            onChange={(e) => setNewFirstName(e.target.value)}
            placeholder="First Name"
          />
          <input
            className="admin-input"
            value={newLastName}
            onChange={(e) => setNewLastName(e.target.value)}
            placeholder="Last Name"
          />
          <input
            className="admin-input"
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
            placeholder="Email"
          />
        </div>

        <div className="admin-form-row">
          <input
            className="admin-input"
            value={newDepartment}
            onChange={(e) => setNewDepartment(e.target.value)}
            placeholder="Department"
          />
          <input
            className="admin-input"
            value={newJobTitle}
            onChange={(e) => setNewJobTitle(e.target.value)}
            placeholder="Job Title"
          />
          <LocationSelect className="admin-input" value={newLocation} onChange={(v: any) => setNewLocation(v)} placeholder="Location" />
        </div>
      </div>

      <div className="content-card">
        <div className="admin-card-header">
          <h3>Users <span style={{ fontSize: '14px', color: '#6b7280', fontWeight: 400 }}>({users.length})</span></h3>
          <input
            className="admin-input"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search users"
          />
        </div>

        <table className="admin-table">
          <thead>
            <tr>
              {showTenantSelector && <th>Tenant</th>}
              <th>User</th>
              <th>Role</th>
              <th>Status</th>
              <th>CC</th>
              <th>Queue</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>
            {users.map((u: AdminUser) => {
              const roleStyle = ROLE_COLORS[u.role || 'pbx_user'] || ROLE_COLORS.pbx_user;
              return (
                <tr key={u.id}>
                  {showTenantSelector && <td>{tenantName((u as any).tenant_id)}</td>}
                  <td>
                    <strong>{u.username}</strong>
                    {u.display_name && u.display_name !== u.username && (
                      <div className="admin-muted">{u.display_name}</div>
                    )}
                    {u.extension_number && (
                      <div className="admin-muted" style={{ fontSize: '11px', color: '#6366f1', fontWeight: 600 }}>
                        Ext {u.extension_number}
                      </div>
                    )}
                  </td>

                  <td>
                    <span style={{
                      ...roleStyle,
                      padding: '3px 10px', borderRadius: '999px',
                      fontSize: '12px', fontWeight: 700,
                    }}>
                      {roleText(u)}
                    </span>
                  </td>

                  <td>
                    <span style={{
                      background: u.is_active ? '#dcfce7' : '#fee2e2',
                      color: u.is_active ? '#166534' : '#991b1b',
                      padding: '3px 10px', borderRadius: '999px',
                      fontSize: '12px', fontWeight: 700,
                    }}>
                      {u.is_active ? 'Active' : 'Disabled'}
                    </span>
                  </td>

                  <td>
                    <span style={{ fontSize: '13px', color: u.cc_enabled ? '#16a34a' : '#9ca3af', fontWeight: 600 }}>
                      {u.cc_enabled ? '✓' : '—'}
                    </span>
                  </td>

                  <td>
                    <span style={{ fontSize: '13px', color: u.queue_enabled ? '#16a34a' : '#9ca3af', fontWeight: 600 }}>
                      {u.queue_enabled ? '✓' : '—'}
                    </span>
                  </td>

                  <td>
                    <div className="admin-action-row">
                      <button
                        className="secondary-btn"
                        onClick={() => setEditingUser(u)}
                      >
                        Edit
                      </button>
                      <button
                        className="danger-btn"
                        onClick={() => deleteUser(u)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}

function QueuesPage({
  queues,
  selectedQueue,
  queueMembers,
  availableAgents,
  newQueueName,
  setNewQueueName,
  newQueueDisplayName,
  setNewQueueDisplayName,
  newQueueStrategy,
  setNewQueueStrategy,
  newQueuePriority,
  setNewQueuePriority,
  createQueue,
  updateQueue,
  deleteQueue,
  loadQueueMembers,
  addMember,
  removeMember,
  tenants,
  showTenantSelector
}: any) {
  const tenantName = (id: any) => { const t=(tenants||[]).find((x: any)=>x.id===Number(id)); return (t && (t.tenant_name||t.name||t.company_name)) || (id?('Tenant '+id):'\u2014'); };
  return (
    <>
      <div className="admin-page-title">Queue Management</div>
      <div className="admin-page-subtitle">
        Create queues, configure strategies, and assign CC agents.
      </div>

      <div className="content-card">
        <h3>Create Queue</h3>

        <div className="admin-form-row">
          <input
            className="admin-input"
            value={newQueueName}
            onChange={(e) => setNewQueueName(e.target.value)}
            placeholder="Queue name e.g. sales"
          />

          <input
            className="admin-input"
            value={newQueueDisplayName}
            onChange={(e) => setNewQueueDisplayName(e.target.value)}
            placeholder="Display name"
          />

          <select
            className="admin-select"
            value={newQueueStrategy}
            onChange={(e) => setNewQueueStrategy(e.target.value)}
          >
            <option value="round_robin">Round Robin</option>
            <option value="least_recent">Least Recent</option>
            <option value="fewest_calls">Fewest Calls</option>
            <option value="ring_all">Ring All</option>
            <option value="random">Random</option>
          </select>

          <input
            className="admin-input"
            type="number"
            value={newQueuePriority}
            onChange={(e) => setNewQueuePriority(Number(e.target.value))}
            placeholder="Priority"
          />

          <button
            className="primary-btn"
            onClick={createQueue}
          >
            Create Queue
          </button>
        </div>
      </div>

      <div className="admin-section-grid">
        <div className="content-card">
          <h3>Queues</h3>

          <table className="admin-table">
            <thead>
              <tr>
                {showTenantSelector && <th>Tenant</th>}
                <th>Queue</th>
                <th>Strategy</th>
                <th>Priority</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {queues.map((q: Queue) => (
                <tr key={q.id}>
                  {showTenantSelector && <td>{tenantName((q as any).tenant_id)}</td>}
                  <td>
                    <strong>{q.display_name}</strong>
                    <div className="admin-muted">{q.queue_name}</div>
                  </td>

                  <td>
                    <select
                      className="admin-select"
                      value={q.strategy || 'round_robin'}
                      onChange={(e) => updateQueue(q, { strategy: e.target.value })}
                    >
                      <option value="round_robin">Round Robin</option>
                      <option value="least_recent">Least Recent</option>
                      <option value="fewest_calls">Fewest Calls</option>
                      <option value="ring_all">Ring All</option>
                      <option value="random">Random</option>
                    </select>
                  </td>

                  <td>
                    <input
                      className="admin-input small"
                      type="number"
                      value={q.priority || 1}
                      onChange={(e) => updateQueue(q, { priority: Number(e.target.value) })}
                    />
                  </td>

                  <td>
                    <TogglePill
                      enabled={!!q.is_active}
                      onClick={() => updateQueue(q, { is_active: q.is_active ? 0 : 1 })}
                      onLabel="Active"
                      offLabel="Disabled"
                    />
                  </td>

                  <td>
                    <div className="admin-action-row">
                      <button
                        className="secondary-btn"
                        onClick={() => loadQueueMembers(q)}
                      >
                        Members
                      </button>

                      <button
                        className="danger-btn"
                        onClick={() => deleteQueue(q)}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="content-card">
          <h3>Queue Members</h3>

          {!selectedQueue && (
            <p className="admin-muted">
              Select a queue to manage members.
            </p>
          )}

          {selectedQueue && (
            <>
              <div className="admin-subtitle-box">
                <strong>{selectedQueue.display_name}</strong>
                <span>{selectedQueue.queue_name}</span>
              </div>

              <h4>Current Members</h4>

              {queueMembers.length === 0 && (
                <p className="admin-muted">No members assigned.</p>
              )}

              {queueMembers.map((m: QueueMember) => (
                <div key={m.id} className="admin-mini-row">
                  <div>
                    <strong>{m.username}</strong>
                    <div className="admin-muted">
                      State: {m.state || 'offline'} | Penalty: {m.penalty}
                    </div>
                  </div>

                  <button
                    className="danger-btn small-btn"
                    onClick={() => removeMember(m)}
                  >
                    Remove
                  </button>
                </div>
              ))}

              <h4 style={{ marginTop: 24 }}>Available CC Agents</h4>

              {availableAgents.length === 0 && (
                <p className="admin-muted">No available CC agents.</p>
              )}

              {availableAgents.map((a: AdminUser) => (
                <div key={a.id} className="admin-mini-row">
                  <div>
                    <strong>{a.username}</strong>
                    <div className="admin-muted">
                      {a.role || 'cc_agent'} | {a.user_type || 'cc_agent'}
                    </div>
                  </div>

                  <button
                    className="primary-btn small-btn"
                    onClick={() => addMember(a)}
                  >
                    Add
                  </button>
                </div>
              ))}
            </>
          )}
        </div>
      </div>
    </>
  );
}

// ── Zoom-style Users page (TEC tenant) ───────────────────────────────────────
// Same props as UsersPage; reuses EditUserModal, ROLE_COLORS/LABELS and all the
// create/update/delete handlers, so behaviour is identical — only the layout
// is the Zoom-console table.
function ZoomUsersPage(props: any) {
  const {
    users, search, setSearch,
    newUsername, setNewUsername, newPassword, setNewPassword,
    newFirstName, setNewFirstName, newLastName, setNewLastName,
    newEmail, setNewEmail, newDepartment, setNewDepartment,
    newJobTitle, setNewJobTitle, newLocation, setNewLocation,
    newExtension, setNewExtension,
    createUser, updateUser, resetPassword, deleteUser,
    tenants, showTenantSelector,
    forceSite, onBranchChanged,
  } = props;

  const [editingUser, setEditingUser] = React.useState<AdminUser | null>(null);
  const [moveUser, setMoveUser] = React.useState<any>(null);   // 2026-10-23: move to another customer
  const [chUser, setChUser] = React.useState<any>(null);       // 2026-10-24: call handling of a user
  const [showAdd, setShowAdd] = React.useState(false);
  const [assignSite, setAssignSite] = React.useState(forceSite || 'central');
  const [branchSites, setBranchSites] = React.useState<any[]>([]);
  // New-user defaults: site, suggested extension, available DID pool (central PBX only)
  const [newDefaults, setNewDefaults] = React.useState<any>(null);
  const [newSiteId, setNewSiteId] = React.useState(String(props.presetSiteId || ''));
  React.useEffect(() => { if (props.presetSiteId) setNewSiteId(String(props.presetSiteId)); }, [props.presetSiteId]);
  const [newDidId, setNewDidId] = React.useState('');
  const [newGw, setNewGw] = React.useState('');
  const ucust = useCustomer();
  const [newCustId, setNewCustId] = React.useState('');
  const custIdRef = React.useRef('');
  custIdRef.current = newCustId;
  const [custDids, setCustDids] = React.useState<any[]>([]);
  React.useEffect(() => { if (showAdd) setNewCustId(ucust.customerId ? String(ucust.customerId) : ''); }, [showAdd]); // eslint-disable-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (!showAdd || !newCustId) { setCustDids([]); return; }
    let alive = true;
    (api as any).get('/api/customers/' + newCustId + '/next-extension').then((r: any) => { if (!alive) return; if (r.data.extension) setNewExtension(String(r.data.extension)); if (r.data.site_id) setNewSiteId(String(r.data.site_id)); }).catch(() => {});
    (api as any).get('/api/customers/' + newCustId).then((r: any) => { if (alive) setCustDids((r.data.dids || []).filter((d: any) => !d.routing_type || !d.destination_value || d.destination_value === 'custom/tec-ad-comingsoon')); }).catch(() => {});
    return () => { alive = false; };
  }, [showAdd, newCustId]); // eslint-disable-line react-hooks/exhaustive-deps
  React.useEffect(() => { setNewGw(''); setNewDidId(''); }, [newSiteId]);
  React.useEffect(() => {
    if (!showAdd || assignSite !== 'central') return;
    let alive = true;
    (api as any).getNewUserDefaults(newSiteId || undefined).then((d: any) => {
      if (!alive) return;
      setNewDefaults(d);
      if (d?.next_extension && !custIdRef.current) setNewExtension(String(d.next_extension));
      if (!newSiteId && d?.site?.id) setNewSiteId(String(d.site.id));
    }).catch(() => setNewDefaults(null));
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAdd, assignSite, newSiteId, newCustId]);
  const newSite = (newDefaults?.sites || []).find((s: any) => String(s.id) === String(newSiteId)) || null;
  const pickedDid = [...(newDefaults?.available_dids || []), ...custDids].find((d: any) => String(d.id) === String(newDidId));
  const gwLabel = (t: any) => (t ? (t.display_name || t.trunk_display || t.trunk_name) : null);
  // Gateway picked for this user (site default first); the DID list follows it
  const siteGws: any[] = newDefaults?.site_gateways || [];
  const effGw = newGw || (siteGws[0] ? siteGws[0].trunk_name : '');
  const effGwObj = siteGws.find((g: any) => g.trunk_name === effGw) || null;
  const didOptions = (newCustId ? custDids : (newDefaults?.available_dids || []).filter((d: any) => !ucust.tagOf('did', d.id)))
    .filter((d: any) => !siteGws.length || d.trunk_name === effGw);
  const siteSelectValue = assignSite === 'central' ? ('pbx:' + (newSiteId || '')) : String(assignSite);
  const onSiteSelect = (v: string) => {
    if (v.startsWith('pbx:')) { setAssignSite('central'); setNewSiteId(v.slice(4)); } else { setAssignSite(v); }
    setNewDidId('');
  };
  React.useEffect(() => {
    const tok = localStorage.getItem('token');
    if (!tok) return;
    Promise.all([
      fetch('/api/v1/admin/sites', { headers: { Authorization: 'Bearer ' + tok } }).then((r) => r.ok ? r.json() : []),
      fetch('/api/v1/admin/edges', { headers: { Authorization: 'Bearer ' + tok } }).then((r) => r.ok ? r.json() : []),
    ]).then(([sites, edges]) => {
      const managed = new Set((edges || []).filter((e: any) => e.management_mode === 'managed').map((e: any) => e.site_id));
      setBranchSites((sites || []).filter((x: any) => managed.has(x.id)));
    }).catch(() => {});
  }, []);
  const tenantName = (id: any) => { const t=(tenants||[]).find((x: any)=>x.id===Number(id)); return (t && (t.tenant_name||t.name||t.company_name)) || (id?('Tenant '+id):'—'); };

  const handleSave = async (u: AdminUser, changes: Partial<AdminUser>, newPw: string) => {
    await updateUser(u, changes);
    if (newPw.trim()) await resetPassword(u, newPw.trim());
    setEditingUser(null);
  };
  const doCreate = async () => {
    if (ucust.enabled) {
      // 2026-10-28: e-mail, department and location are optional (e-mail format checked only when entered)
      const miss = [['First name', newFirstName], ['Last name', newLastName]]
        .filter(([, v]) => !String(v || '').trim()).map(([k]) => k);
      if (miss.length) { alert('Please fill in the mandatory fields: ' + miss.join(', ')); return; }
      if (String(newEmail || '').trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(newEmail).trim())) { alert('The e-mail address is not valid (or leave it empty).'); return; }
    }
    if (assignSite === 'central') { await createUser({ site_id: newSiteId ? Number(newSiteId) : undefined, did_id: newDidId ? Number(newDidId) : undefined, gateway: (siteGws.length && effGw) ? effGw : undefined, customer_id: newCustId ? Number(newCustId) : undefined }); setNewDidId(''); setShowAdd(false); loadCustomers(); return; }
    const tok = localStorage.getItem('token');
    const ext = (newExtension || newUsername || '').trim();
    if (!/^[0-9]{2,8}$/.test(ext)) { alert('For a branch user, enter a numeric extension (2-8 digits) in Username/Extension or Extension.'); return; }
    try {
      const r = await fetch('/api/v1/admin/sites/' + assignSite + '/extensions', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + tok },
        body: JSON.stringify({ extension: ext, username: (newUsername || '').trim() || ext, password: (newPassword || '').trim() || undefined, display_name: [newFirstName, newLastName].filter(Boolean).join(' ').trim() || undefined, first_name: (newFirstName || '').trim() || undefined, last_name: (newLastName || '').trim() || undefined, email: (newEmail || '').trim() || undefined, department: (newDepartment || '').trim() || undefined, job_title: (newJobTitle || '').trim() || undefined, location: (newLocation || '').trim() || undefined }),
      });
      const d = await r.json();
      if (!r.ok) { alert(d.error || 'Could not create branch user'); return; }
      alert('Branch user ' + d.extension + ' created and pushed to the branch server.\nSIP password: ' + (d.sip_password || (newPassword || '').trim()) + '\nManage under Branches / Edge -> Edge Servers.');
      setShowAdd(false); if (!forceSite) setAssignSite('central');
      setNewUsername(''); setNewPassword(''); setNewFirstName(''); setNewLastName(''); setNewExtension('');
      if (setNewEmail) setNewEmail(''); if (setNewDepartment) setNewDepartment(''); if (setNewJobTitle) setNewJobTitle(''); if (setNewLocation) setNewLocation('');
      if (onBranchChanged) onBranchChanged();
    } catch (e: any) { alert(e.message || 'error'); }
  };

  const columns: any[] = [
    { key: 'user', label: 'Email / Name ID', render: (u: any) => (
      <div>
        <div className="z-tbl-primary-cell">{u.username}</div>
        {(u.email || u.display_name) && <div className="z-tbl-sub">{u.email || u.display_name}</div>}
      </div>
    ) },
    { key: 'first_name', label: 'First Name', render: (u: any) => u.first_name || '—' },
    { key: 'last_name', label: 'Last Name', render: (u: any) => u.last_name || '—' },
    { key: 'role', label: 'Role', render: (u: any) => {
      const rs = ROLE_COLORS[telRole(u)] || ROLE_COLORS.pbx_user;
      return <span style={{ ...rs, padding: '3px 10px', borderRadius: 6, fontSize: 12, fontWeight: 700 }}>{roleText(u)}</span>;
    } },
    { key: 'access_group', label: 'Access group', render: (u: any) => u.access_group || '—' },
    { key: 'ext', label: 'Extension', render: (u: any) => u.extension_number ? <ZoomBadge text={`Ext ${u.extension_number}`} tone="blue" /> : '—' },
    { key: 'dids', label: 'Direct number', render: (u: any) => (u.dids || []).length
      ? <div style={{ display: 'flex', flexDirection: 'column', gap: 2, whiteSpace: 'nowrap' }}>{u.dids.map((d: string) => <span key={d}>{d}</span>)}</div> : '—' },
    { key: 'status', label: 'Status', render: (u: any) => <ZoomBadge text={u.is_active ? 'Active' : 'Disabled'} tone={u.is_active ? 'green' : 'red'} /> },
    { key: 'department', label: 'Department', render: (u: any) => u.department || '—' },
  ];
  if (showTenantSelector) columns.splice(1, 0, { key: 'tenant', label: 'Tenant', render: (u: any) => tenantName(u.tenant_id) });
  if (ucust.enabled) columns.splice(1, 0, { key: 'customer', label: 'Customer', render: (u: any) => ucust.nameOf(ucust.tagOf('user', u.id)) || '—' });

  return (
    <>
      {editingUser && (
        <EditUserModal user={editingUser} onSave={handleSave} onClose={() => setEditingUser(null)} onDelete={deleteUser} />
      )}
      {moveUser && <MoveUserDialog user={moveUser} onClose={() => setMoveUser(null)} onDone={() => { try { ucust.reload && ucust.reload(); } catch (_) {} }} />}
      {chUser && <CallHandlingDialog userId={chUser.id} name={chUser.name} onClose={() => setChUser(null)} />}

      {showAdd && (
        <ZoomModal
          title="Add User"
          onClose={() => setShowAdd(false)}
          footer={<><ZoomBtn onClick={() => setShowAdd(false)}>Cancel</ZoomBtn><ZoomBtn variant="primary" onClick={doCreate}>Add</ZoomBtn></>}
        >
          <div className="z-field-grid">
            {!forceSite && <ZoomField label="Site" hint={assignSite !== 'central' ? 'Provisions to the branch server' : (newSite ? (newSite.by_assignment ? newSite.name : ('Extensions ' + newSite.ext_start + '-' + newSite.ext_end)) : 'Central phone system')}><select value={siteSelectValue} onChange={(e) => onSiteSelect(e.target.value)}>{(newDefaults?.sites || []).length ? newDefaults.sites.map((s: any) => <option key={'p' + s.id} value={'pbx:' + s.id}>{s.name}</option>) : <option value="pbx:">Central - main system (Dubai)</option>}{branchSites.map((x: any) => <option key={x.id} value={x.id}>{x.name} Edge (branch server)</option>)}</select></ZoomField>}
            {ucust.enabled && assignSite === 'central' && (
              <ZoomField label="Customer" hint={newCustId ? 'Extension from the customer\'s block; caller ID = its main number unless a DID is picked' : `${orgName()}'s own user`}>
                <select value={newCustId} onChange={(e) => { setNewCustId(e.target.value); setNewDidId(''); if (!e.target.value) setNewExtension(''); }}>
                  <option value="">{orgName()} (own user)</option>
                  {ucust.cfg.customers.filter((c: any) => c.status === 'active').map((c: any) => <option key={c.id} value={String(c.id)}>{c.name} ({c.code})</option>)}
                </select>
              </ZoomField>
            )}
            <ZoomField label="Username / Extension"><input value={newUsername} onChange={(e) => setNewUsername(e.target.value)} placeholder="e.g. 2001" /></ZoomField>
            <ZoomField label="Password"><input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="Password" /></ZoomField>
            <ZoomField label={'First Name' + (ucust.enabled ? ' *' : '')}><input value={newFirstName} onChange={(e) => setNewFirstName(e.target.value)} /></ZoomField>
            <ZoomField label={'Last Name' + (ucust.enabled ? ' *' : '')}><input value={newLastName} onChange={(e) => setNewLastName(e.target.value)} /></ZoomField>
            <ZoomField label="Email (optional)"><input value={newEmail} onChange={(e) => setNewEmail(e.target.value)} /></ZoomField>
            <ZoomField label="Extension" hint={assignSite === 'central' ? ('Next free number filled in - you can change it' + (newSite && !newSite.by_assignment ? ' (' + newSite.ext_start + '-' + newSite.ext_end + ')' : '')) : 'Auto-assigned if blank'}><input value={newExtension} onChange={(e) => setNewExtension(e.target.value)} /></ZoomField>
            {assignSite === 'central' && siteGws.length > 1 && (
              <ZoomField label="Gateway" hint="Pick the gateway first - the DID list shows only its numbers">
                <select value={effGw} onChange={(e) => { setNewGw(e.target.value); setNewDidId(''); }}>
                  {siteGws.map((g: any, i: number) => (
                    <option key={g.trunk_name} value={g.trunk_name}>{gwLabel(g)}{i === 0 ? ' (default)' : ''}</option>
                  ))}
                </select>
              </ZoomField>
            )}
            {assignSite === 'central' && (
              <ZoomField label="DID (optional)" hint={pickedDid
                ? ('Dials out via ' + (gwLabel(pickedDid) || 'the default gateway') + ' with caller ID ' + pickedDid.did_number)
                : ('No DID - dials out via ' + (gwLabel(effGwObj || newDefaults?.default_gateway) || 'the default gateway'))}>
                <select value={newDidId} onChange={(e) => setNewDidId(e.target.value)}>
                  <option value="">No DID</option>
                  {didOptions.map((d: any) => (
                    <option key={d.id} value={d.id}>{d.did_number}{d.trunk_name ? ' - ' + (d.trunk_display || d.trunk_name) : ''}</option>
                  ))}
                </select>
              </ZoomField>
            )}
            <ZoomField label="Department (optional)"><input value={newDepartment} onChange={(e) => setNewDepartment(e.target.value)} /></ZoomField>
            <ZoomField label="Job Title"><input value={newJobTitle} onChange={(e) => setNewJobTitle(e.target.value)} /></ZoomField>
            <ZoomField label="Location (optional)"><input value={newLocation} onChange={(e) => setNewLocation(e.target.value)} /></ZoomField>
          </div>
        </ZoomModal>
      )}

      <ZoomTable
        title="Users"
        subtitle="Create and manage PBX users, agents, supervisors and admins."
        tabs={['Users']}
        activeTab="Users"
        banner={<span>Manage your users, roles and extensions here. Assigning an extension enables calling.</span>}
        search={search}
        onSearch={setSearch}
        searchPlaceholder="Search users"
        actions={<>
          <ZoomBtn onClick={() => alert('Bulk import — coming soon')}>Import</ZoomBtn>
          <ZoomBtn onClick={() => alert('Export — coming soon')}>Export</ZoomBtn>
          <ZoomBtn variant="primary" onClick={() => {
            setNewUsername(''); setNewPassword(''); setNewFirstName(''); setNewLastName(''); setNewExtension('');
            if (setNewEmail) setNewEmail(''); if (setNewDepartment) setNewDepartment(''); if (setNewJobTitle) setNewJobTitle(''); if (setNewLocation) setNewLocation('');
            setNewDidId(''); setNewGw(''); setNewCustId('');
            setShowAdd(true);
          }}>+ Add Users</ZoomBtn>
        </>}
        columns={columns}
        rows={users}
        rowKey={(u: any) => u.id}
        rowActions={(u: any) => (
          <>
            <ZoomBtn onClick={() => setEditingUser(u)}>Edit</ZoomBtn>
            <ZoomBtn onClick={() => setChUser({ id: u.id, name: [u.first_name, u.last_name].filter(Boolean).join(' ') || u.username })}>Call handling</ZoomBtn>
            {ucust.enabled && ['pbx_user', 'agent', 'supervisor'].includes(u.role || 'pbx_user') && <ZoomBtn onClick={() => setMoveUser({ id: u.id, name: [u.first_name, u.last_name].filter(Boolean).join(' ') || u.username, customer_id: ucust.tagOf('user', u.id) })}>Move customer</ZoomBtn>}
            <ZoomBtn variant="danger" onClick={() => deleteUser(u)}>Delete</ZoomBtn>
          </>
        )}
        emptyText="No users yet"
      />
    </>
  );
}

// ── Zoom-style Queues page (TEC tenant) ───────────────────────────────────────
function ZoomQueuesPage(props: any) {
  const {
    queues, selectedQueue, queueMembers, availableAgents,
    newQueueName, setNewQueueName, newQueueDisplayName, setNewQueueDisplayName,
    newQueueStrategy, setNewQueueStrategy, newQueuePriority, setNewQueuePriority,
    createQueue, updateQueue, deleteQueue, loadQueueMembers, addMember, removeMember,
    tenants, showTenantSelector, reloadQueues,
  } = props;

  const [search, setSearch] = React.useState('');
  const [showAdd, setShowAdd] = React.useState(false);
  const [membersOpen, setMembersOpen] = React.useState(false);
  const [qtab, setQtab] = React.useState('Queues');
  const [settingsQ, setSettingsQ] = React.useState<any>(null);
  const [qinfo, setQinfo] = React.useState<any>({});
  const loadQinfo = React.useCallback(() => {
    axios.get('/api/queues/live').then((r) => {
      const m: any = {}; (Array.isArray(r.data) ? r.data : []).forEach((x: any) => { m[x.id] = x; }); setQinfo(m);
    }).catch(() => {});
  }, []);
  React.useEffect(() => { loadQinfo(); }, [loadQinfo, queues]);
  const tenantName = (id: any) => { const t=(tenants||[]).find((x: any)=>x.id===Number(id)); return (t && (t.tenant_name||t.name||t.company_name)) || (id?('Tenant '+id):'—'); };

  const STRATS = [
    { v: 'round_robin', l: 'Round Robin' }, { v: 'least_recent', l: 'Least Recent' },
    { v: 'fewest_calls', l: 'Fewest Calls' }, { v: 'ring_all', l: 'Ring All' }, { v: 'random', l: 'Random' },
  ];
  const qcust = useCustomer();
  const filtered = (queues || []).filter((q: any) => qcust.match('queue', q.id)).filter((q: any) =>
    !search.trim() || `${q.display_name} ${q.queue_name}`.toLowerCase().includes(search.toLowerCase()));

  const openMembers = (q: any) => { loadQueueMembers(q); setMembersOpen(true); };
  const doCreate = async () => { await createQueue(); setShowAdd(false); };

  const columns: any[] = [
    { key: 'queue', label: 'Queue', render: (q: any) => (
      <div><div className="z-tbl-primary-cell">{q.display_name}</div><div className="z-tbl-sub">{q.queue_name}</div></div>
    ) },
    { key: 'mode', label: 'Mode', render: (q: any) => {
      const i = qinfo[q.id];
      if (!i) return <span className="z-tbl-sub">—</span>;
      if (i.call_engine !== 'smart') return <span className={'z-badge z-badge-gray'}>Classic</span>;
      return <span style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}><span className="z-badge z-badge-blue">Smart</span>
        {Number(i.force_closed) ? <span className="z-badge z-badge-red">Closed now</span> : null}
        {i.live && i.live.waiting ? <span className="z-badge z-badge-amber">{i.live.waiting} waiting</span> : null}</span>;
    } },
    { key: 'strategy', label: 'Ring Strategy', render: (q: any) => (
      <select className="z-inline-select" value={q.strategy || 'round_robin'} onChange={(e) => updateQueue(q, { strategy: e.target.value })}>
        {STRATS.map(s => <option key={s.v} value={s.v}>{s.l}</option>)}
      </select>
    ) },
    { key: 'priority', label: 'Priority', render: (q: any) => (
      <input className="z-inline-input" type="number" value={q.priority || 1} onChange={(e) => updateQueue(q, { priority: Number(e.target.value) })} />
    ) },
    { key: 'status', label: 'Status', render: (q: any) => (
      <button className={`z-badge ${q.is_active ? 'z-badge-green' : 'z-badge-red'}`} style={{ border: 'none', cursor: 'pointer' }}
        onClick={() => updateQueue(q, { is_active: q.is_active ? 0 : 1 })}>
        {q.is_active ? 'Active' : 'Disabled'}
      </button>
    ) },
  ];
  if (showTenantSelector) columns.splice(1, 0, { key: 'tenant', label: 'Tenant', render: (q: any) => tenantName(q.tenant_id) });

  if (qtab !== 'Queues') return (
    <>
      <QueueTabBar tab={qtab} setTab={setQtab} />
      {qtab === 'Live' && <QueueLive />}
      {qtab === 'Reports' && <QueueReports />}
      {qtab === 'Missed calls' && <QueueMissed />}
      {qtab === 'Voicemail' && <QueueVoicemail />}
    </>
  );
  return (
    <>
      <QueueTabBar tab={qtab} setTab={setQtab} />
      {settingsQ && <QueueSettingsModal queueId={settingsQ.id} onClose={() => setSettingsQ(null)}
        onSaved={() => { loadQinfo(); if (reloadQueues) reloadQueues(); }} />}
      {showAdd && (
        <ZoomModal
          title="Add Call Queue"
          onClose={() => setShowAdd(false)}
          footer={<><ZoomBtn onClick={() => setShowAdd(false)}>Cancel</ZoomBtn><ZoomBtn variant="primary" onClick={doCreate}>Create</ZoomBtn></>}
        >
          <ZoomField label="Queue Name" hint="Internal name, e.g. sales"><input value={newQueueName} onChange={(e) => setNewQueueName(e.target.value)} placeholder="sales" /></ZoomField>
          <ZoomField label="Display Name"><input value={newQueueDisplayName} onChange={(e) => setNewQueueDisplayName(e.target.value)} placeholder="Sales Team" /></ZoomField>
          <div className="z-field-grid">
            <ZoomField label="Ring Strategy">
              <select value={newQueueStrategy} onChange={(e) => setNewQueueStrategy(e.target.value)}>
                {STRATS.map(s => <option key={s.v} value={s.v}>{s.l}</option>)}
              </select>
            </ZoomField>
            <ZoomField label="Priority"><input type="number" value={newQueuePriority} onChange={(e) => setNewQueuePriority(Number(e.target.value))} /></ZoomField>
          </div>
        </ZoomModal>
      )}

      {membersOpen && selectedQueue && (
        <ZoomModal title={`Members — ${selectedQueue.display_name}`} onClose={() => setMembersOpen(false)} width={620}
          footer={<ZoomBtn variant="primary" onClick={() => setMembersOpen(false)}>Done</ZoomBtn>}>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#344054', marginBottom: 8 }}>Current Members</div>
          {(!queueMembers || queueMembers.length === 0) && <div className="z-tbl-sub" style={{ marginBottom: 12 }}>No members assigned.</div>}
          {(queueMembers || []).map((m: any) => (
            <div key={m.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #F0F3F8' }}>
              <div><strong>{m.username}</strong> <span className="z-tbl-sub">state: {m.state || 'offline'} · penalty {m.penalty}</span></div>
              <ZoomBtn variant="danger" onClick={() => removeMember(m)}>Remove</ZoomBtn>
            </div>
          ))}
          <div style={{ fontSize: 13, fontWeight: 700, color: '#344054', margin: '18px 0 8px' }}>Available Agents</div>
          {(!availableAgents || availableAgents.length === 0) && <div className="z-tbl-sub">No available agents.</div>}
          {(availableAgents || []).map((a: any) => (
            <div key={a.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #F0F3F8' }}>
              <div><strong>{a.username}</strong> <span className="z-tbl-sub">{a.role || 'cc_agent'}</span></div>
              <ZoomBtn variant="primary" onClick={() => addMember(a)}>Add</ZoomBtn>
            </div>
          ))}
        </ZoomModal>
      )}

      <ZoomTable
        title="Call Queues"
        subtitle="Create queues and assign agents. Settings: hours, greetings, music, waiting limits, overflow, queue voicemail and VIP callers."
        search={search}
        onSearch={setSearch}
        searchPlaceholder="Search queues"
        actions={<ZoomBtn variant="primary" onClick={() => { setNewQueueName(''); setNewQueueDisplayName(''); setShowAdd(true); }}>+ Add Queue</ZoomBtn>}
        columns={columns}
        rows={filtered}
        rowKey={(q: any) => q.id}
        rowActions={(q: any) => (
          <>
            <ZoomBtn variant="primary" onClick={() => setSettingsQ(q)}>Settings</ZoomBtn>
            {!isOpsSession() && <ZoomBtn onClick={() => openMembers(q)}>Members</ZoomBtn>}
            <ZoomBtn variant="danger" onClick={() => deleteQueue(q)}>Delete</ZoomBtn>
          </>
        )}
        emptyText="No queues yet"
      />
    </>
  );
}

function PlaceholderPage({
  title,
  subtitle
}: {
  title: string;
  subtitle: string;
}) {
  return (
    <>
      <div className="admin-page-title">{title}</div>
      <div className="admin-page-subtitle">{subtitle}</div>

      <div className="content-card">
        <h3>Coming Next</h3>
        <p>
          This section will be implemented in the next phase.
        </p>
      </div>
    </>
  );
}

function StatCard({ title, value }: any) {
  return (
    <div className="stat-card">
      <div className="stat-title">{title}</div>
      <div className="stat-value">{value}</div>
    </div>
  );
}

function TogglePill({
  enabled,
  onClick,
  onLabel = 'ON',
  offLabel = 'OFF'
}: any) {
  return (
    <button
      onClick={onClick}
      className={`admin-pill ${enabled ? 'green' : 'red'}`}
    >
      {enabled ? onLabel : offLabel}
    </button>
  );
}